export default {
    "MIME-Version": "1.0",
    "Content-Type": "text/plain; charset=utf-8",
    "Content-Transfer-Encoding": "8bit",
    "X-Generator": "Ideo Core",
    "PO-Revision-Date": "2025-01-16T18:28:34.737Z",
    "Last-Translator": "",
    "Language-Team": "",
    "Language": "en-US",
    "Messages": {
        "1": "1",
        "2": "2",
        "3": "3",
        "4": "4",
        "%0 %1 temu": "%0 %1 ago",
        "%0 ostrzeżeń": "%0 warnings",
        "%0 plików": "%0 files",
        "%0 wierszy · %1 px": "%0 rows · %1 px",
        "%0 z %1": "%0 of %1",
        "%0 z %1 uprawnień aktywnych": "%0 of %1 active privileges",
        "%0 z 12 kolumn siatki": "%0 of 12 grid columns",
        "%0 zaznaczono": "%0 selected",
        "%0 znaków": "%0 characters",
        "<Brak nazwy>": "<No name>",
        "<iframe src=\"...\"></iframe>": "<iframe src=\"...\"></iframe>",
        "1 godzina": "1 hour",
        "1 ostrzeżenie": "1 warning",
        "1:1 kwadrat": "1:1 square",
        "10 minut": "10 minutes",
        "1024x1024": "1024x1024",
        "1024x1536": "1024x1536",
        "12 godzin": "12 hours",
        "15 minut": "15 minutes",
        "1536x1024": "1536x1024",
        "16:9 panoramiczny": "16:9 panoramic",
        "24 godziny": "24 hours",
        "3 godziny": "3 hours",
        "3:4 portret": "3:4 portrait",
        "30 minut": "30 minutes",
        "4:3 standard": "4:3 standard",
        "5 minut": "5 minutes",
        "6 godzin": "6 hours",
        "9:16 mobile": "9:16 mobile",
        "Abstrakcyjne tło w kolorach marki, gradient": "Abstract background in brand colors, gradient",
        "Aby móc przetestować poprawność kluczy, najpierw zapisz formularz.": "To test the validity of keys, first save the form.",
        "Administracja": "Administration",
        "Administracja - Kraje": "Administration - Countries",
        "Administracja - Miasta": "Administration - Cities",
        "Administracja - Role": "Administration - Roles",
        "Administracja - Stanowiska pracy": "Administration - Job positions",
        "Administracja - Użytkownicy": "Administration - Users",
        "Administracja - Województwa": "Administration - Provinces",
        "Administracja - Zespoły": "Administration - Teams",
        "Administrator": "Administrator",
        "Administratorzy": "Administrators",
        "Adres bazowy API dostawcy.": "Base API URL of the provider.",
        "Adres domenowy": "Domain address",
        "Adres e-mail": "Email address",
        "Adres e-mail administratora": "Administrator email address",
        "Adres e-mail potwierdzony": "Email address confirmed",
        "Adres email jest wymagany": "Email address is required",
        "Adres email nadawcy": "Sender's email address",
        "Adres IP": "IP address",
        "Adres lub connection string używany do eksportu telemetrii.": "Address or connection string used to export telemetry.",
        "Adres nie istnieje lub zasób został usunięty.\nSprawdź link albo poszukaj treści w panelu.": "Address does not exist or resource has been deleted.\nCheck link or search for content in panel.",
        "Adres powiadomień systemowych i resetu hasła.": "Address for system notifications and password reset.",
        "Adres projektu Sentry, do którego trafiają zdarzenia.": "Sentry project address where events are sent.",
        "Adres serwera poczty wychodzącej.": "Outgoing mail server address.",
        "Adres URL": "URL address",
        "Adres używany do logowania, powiadomień i odzyskiwania dostępu.": "Address used for login, notifications, and account recovery.",
        "Adres w polu „Od” wysyłanych wiadomości.": "Address in the “From” field of sent messages.",
        "Adres źródłowy lub nazwa miejsca, z którego pochodzi materiał.": "Source address or name of place where material originated.",
        "Adresy rozdziel przecinkami. Każdy musi zaczynać się od http lub https.": "Separate addresses with commas. Each must start with http or https.",
        "Agent chce wykonać operację:": "Agent wants to perform operation:",
        "AI": "AI",
        "Akapit": "Paragraph",
        "Akcja": "Action",
        "Akcje": "Actions",
        "Akcje {name}": "{name} actions",
        "Akcje folderu": "Folder actions",
        "Akcje pliku": "File actions",
        "Akordeon": "Accordion",
        "Aktualizuj": "Update",
        "Aktualizuj zestaw": "Update set",
        "Aktualna": "Current",
        "Aktualna sesja": "Current session",
        "Aktualne hasło": "Current password",
        "Aktywna": "Active",
        "Aktywne": "Active",
        "Aktywne sesje": "Active sessions",
        "Aktywni": "Active",
        "Aktywny": "Active",
        "Aktywuj": "Activate",
        "Akwarela": "Watercolor",
        "Alt opisuje obraz osobom korzystającym z czytników ekranu i jest używany, gdy obraz nie może się załadować.": "Alt text describes image to people using screen readers and is used when image cannot load.",
        "Analiza": "Analysis",
        "Analiza obrazów": "Image analysis",
        "Analiza obrazów, rozpoznawanie wzorów wizualnych": "Image analysis and visual pattern recognition",
        "Angielski": "English",
        "Anonimizuj": "Anonymize",
        "Anonimowy": "Anonymous",
        "Anulowano": "Canceled",
        "Anulowano zmianę pozycji widgetu %0.": "Canceled move of widget %0.",
        "Anuluj": "Cancel",
        "Anuluj dodawanie urządzenia": "Cancel adding device",
        "Anuluj zmianę nazwy": "Cancel rename",
        "Aplikacja monitorująca": "Monitoring application",
        "Aplikacja uwierzytelniająca": "Authenticator app",
        "Aplikacja uwierzytelniająca została skonfigurowana.": "Authenticator app has been configured.",
        "Aplikacja zostanie zrestartowana w przeciągu maksymalnie 60 sekund.": "Application will restart within a maximum of 60 seconds.",
        "Aranżacja": "Arrangement",
        "Artykuł": "Article",
        "Asystent AI": "AI assistant",
        "Asystent będzie wykonywał wszystkie dozwolone operacje bez pytania, również nieodwracalne usuwanie danych.": "Assistant will perform all permitted operations without asking, including irreversible data deletion.",
        "Asystent czeka na Twoje potwierdzenie.": "Assistant is waiting for your confirmation.",
        "Asystent napotkał błąd serwera. Spróbuj ponownie za chwilę.": "Assistant encountered a server error. Try again in a moment.",
        "Asystent nie jest włączony w konfiguracji AI. Skontaktuj się z administratorem.": "Assistant is not enabled in AI settings. Contact administrator.",
        "Asystent nie widzi Edito": "Assistant cannot see Edito",
        "Asystent pracuje...": "Assistant is working...",
        "Asystent prosi o repozytorium": "Assistant is requesting a repository",
        "Asystent zakończył zadanie.": "Assistant has completed the task.",
        "Automatyczne zamknięcie panelu. Najedź kursorem, aby wstrzymać.": "Panel closes automatically. Hover to pause.",
        "Autonomiczny": "Autonomous",
        "Autor": "Author",
        "Autoryzacja wymagana": "Authorization required",
        "Azure AD": "Azure AD",
        "Azure Application Insights": "Azure Application Insights",
        "Bardzo dobre": "Very good",
        "Basic Auth": "Basic Auth",
        "Baza danych": "Database",
        "Bez koloru": "No color",
        "Bez potwierdzeń, również przy usuwaniu": "No confirmations, including when deleting",
        "Bez przycinania": "No cropping",
        "Bezpieczeństwo": "Security",
        "Bezpieczne połączenie SSL": "Secure SSL connection",
        "Biblioteka": "Library",
        "Biblioteka plików": "File library",
        "Błąd 404. Nie znaleziono żądanego zasobu.": "Error 404. Requested resource not found.",
        "Błąd asystenta": "Assistant error",
        "Błąd cofania zmian": "Error undoing changes",
        "Błąd pobierania rozmów": "Error fetching conversations",
        "Błąd pobierania rozmowy": "Error fetching conversation",
        "Błąd połączenia": "Connection error",
        "Błąd potwierdzenia operacji": "Error confirming operation",
        "Błąd serwera": "Server error",
        "Błąd wysyłania załącznika": "Error uploading attachment",
        "Błędne": "Invalid",
        "Błędy": "Errors",
        "Błękitny": "Light blue",
        "Blok kodu": "Code block",
        "Blokada konta": "Account lock",
        "Blokada konta do": "Account lock until",
        "Blokada konta i sesja": "Account lock and session",
        "Blokady": "Locks",
        "Bool": "Bool",
        "Brak": "None",
        "Brak aktywnych ankiet z odpowiedziami do pokazania.": "No active surveys with responses to show.",
        "Brak aktywnych sesji.": "No active sessions.",
        "Brak aktywnych zastępstw w wybranym miesiącu.": "No active substitutions in selected month.",
        "Brak danych": "No data",
        "Brak danych inspekcji": "No inspection data",
        "Brak dodatkowych metadanych": "No additional metadata",
        "Brak dodatkowych stylów": "No additional styles",
        "Brak dostawcy": "No provider",
        "Brak dostępnych opcji": "No options available",
        "Brak elementów": "No items",
        "Brak elementów.": "No items.",
        "Brak ikon pasujących do wyszukiwania.": "No icons matching search.",
        "Brak kluczy": "No keys",
        "Brak nowych powiadomień.": "No new notifications.",
        "Brak ostrzeżeń": "No warnings",
        "Brak pasujących dashboardów.": "No matching dashboards.",
        "Brak pasujących kolumn": "No matching columns",
        "Brak pasujących plików": "No matching files",
        "Brak pasujących ról.": "No matching roles.",
        "Brak pasujących zestawów": "No matching sets",
        "Brak pliku": "No file",
        "Brak produktów do wyświetlenia według aktualnych kryteriów.": "No products to display based on current criteria.",
        "Brak przypisania": "No assignment",
        "Brak ról": "No roles",
        "Brak rozmów": "No conversations",
        "Brak różnic między wersjami": "No differences between versions",
        "Brak skonfigurowanych urządzeń": "No devices configured",
        "Brak treści": "No content",
        "Brak treści do wyświetlenia w wybranym zakresie.": "No content to display in selected range.",
        "Brak uprawnień": "No privileges",
        "Brak uprawnień do asystenta.": "No privileges for assistant.",
        "Brak użytkownika": "No user",
        "Brak użytkowników lub rejestracji do wyświetlenia w tym zakresie.": "No users or registrations to display in this range.",
        "Brak wersji": "No version",
        "Brak witryn.": "No sites.",
        "Brak wpisów do wyświetlenia": "No entries to display",
        "Brak wpisów w dzienniku.": "No log entries.",
        "Brak wyboru": "No selection",
        "Brak wyników": "No results",
        "Brak wyników dla podanego wyszukiwania.": "No results for search query.",
        "Brak zapamiętanych urządzeń.": "No remembered devices.",
        "Brak zapisanych zestawów": "No saved sets",
        "Brak zdefiniowanych ról.": "No roles defined.",
        "Brak zmian dla wybranego filtra": "No changes for selected filter",
        "Brakuje emoji?": "Missing an emoji?",
        "Brakuje informacji o typie jednego z plików. Odśwież listę.": "Information about the type of one of the files is missing. Refresh the list.",
        "Brakuje znaku?": "Missing a character?",
        "Breakpoint nieustawiony": "Breakpoint not set",
        "Brzoskwiniowy": "Peach",
        "Build": "Build",
        "Cały obraz": "Full image",
        "Caption wyświetla się nad tabelą i poprawia jej dostępność dla czytników ekranu.": "Caption is displayed above the table and improves its accessibility for screen reader users.",
        "Chat": "Chat",
        "Chat i krótkie podsumowania o niskiej latencji.": "Chat and short low-latency summaries.",
        "Chat, generowanie treści i podsumowań - szybkie odpowiedzi": "Chat, content generation and summaries - quick responses",
        "Chat, generowanie treści i podsumowań - zaawansowane odpowiedzi": "Chat, content generation and summaries - advanced responses",
        "Chat, generowanie treści i podsumowań.": "Chat, content generation and summaries.",
        "Ciemny nagłówek": "Dark header",
        "Claude Code - instalacja i pierwsze kroki": "Claude Code - installation and getting started",
        "Claude Code - połączenia MCP": "Claude Code - MCP connections",
        "Claude Code Desktop - rozpoczęcie pracy": "Claude Code Desktop - getting started",
        "Claude nie pokazuje karty Code": "Claude doesn't show Code tab",
        "Claymation": "Claymation",
        "Client ID": "Client ID",
        "Client Secret": "Client Secret",
        "Co {interval} {unit}": "Every {interval} {unit}",
        "co 3 miesiące": "every 3 months",
        "co 30 dni": "every 30 days",
        "co 6 miesięcy": "every 6 months",
        "Co będzie potrzebne": "What you'll need",
        "Co było nie tak? (opcjonalnie)": "What went wrong? (optional)",
        "Co godzinę": "Every hour",
        "Co któreś": "Every other",
        "Co miesiąc": "Every month",
        "Co minutę": "Every minute",
        "Co możesz zrobić": "What you can do",
        "co rok": "every year",
        "Co zrobić": "What to do",
        "Codex - aplikacja i instalacja": "Codex - app and installation",
        "Codex - konfiguracja projektu": "Codex - project configuration",
        "Codex - projekty i foldery": "Codex - projects and folders",
        "Codziennie": "Daily",
        "Cofanie w toku...": "Undoing in progress...",
        "Cofnąć te zmiany? Wykonam operacje odwrotne przez narzędzia CMS.": "Undo these changes? I’ll perform reverse operations using CMS tools.",
        "Cofnięcie odrzucone — zmiana pozostaje.": "Undo rejected — change remains.",
        "Cofnięto": "Undone",
        "Cofnij": "Undo",
        "Cofnij zmiany": "Undo changes",
        "Coś nie zadziałało po naszej stronie.\nSpróbuj ponownie za chwilę.": "Something went wrong on our end.\nTry again in a moment.",
        "Coś nie zadziałało po naszej stronie.\nZdarzenie zostało zapisane - spróbuj ponownie za chwilę.": "Something went wrong on our end.\nEvent has been logged - try again in a moment.",
        "Cron": "Cron",
        "CSS gradientu": "Gradient CSS",
        "Cyberpunk": "Cyberpunk",
        "cyfra %0 z %1": "digit %0 of %1",
        "Cyfrowe malarstwo": "Digital painting",
        "Cytat": "Quote",
        "Czas na zatwierdzenie planu minął.": "Time to approve plan has expired.",
        "Czas nieaktywności użytkownika": "User inactivity time",
        "Czas trwania blokady": "Lock duration",
        "Czas uruchomienia": "Run time",
        "Czego szukasz?": "What are you looking for?",
        "czeka na potwierdzenie": "waiting for confirmation",
        "czerwiec": "June",
        "Część": "Part",
        "Część harmonogramu": "Schedule section",
        "Część wklejonej treści została usunięta ze względów bezpieczeństwa.": "Part of pasted content was removed for security reasons.",
        "Czy na pewno chcesz opuścić widok bez zapisywania?": "Are you sure you want to leave view without saving?",
        "Czy na pewno chcesz usunąć sekcję wraz z treścią?": "Are you sure you want to delete section and its content?",
        "Czy na pewno chcesz usunąć to urządzenie?": "Are you sure you want to delete this device?",
        "Czy na pewno chcesz usunąć widget?": "Are you sure you want to delete the widget?",
        "Czy na pewno chcesz usunąć wybrane pliki i katalogi?": "Are you sure you want to delete selected files and folders?",
        "Czy na pewno chcesz zrestartować aplikację?": "Are you sure you want to restart application?",
        "Czyści zaznaczenia w formularzu i ustawia wyrażenie * * * * *. Zmiany pozostają lokalne do kliknięcia „Zapisz”.": "Clears form selections and sets expression to * * * * *. Changes remain local until you click “Save”.",
        "Czytniki ekranu i użytkownicy nie widzą, gdzie prowadzi link bez tekstu. Taki link może też wyglądać jak przypadkowy znacznik w treści.": "Screen reader users and other users can't tell where a link without text leads. Such a link may also look like an accidental marker in content.",
        "Dalej": "Next",
        "Dane dodatkowe": "Additional data",
        "Dane inspekcji są niedostępne": "Inspection data are unavailable",
        "Dane pliku": "File data",
        "Dane po zmianie": "Data after change",
        "Dane przed zmianą": "Data before change",
        "Dane serwera używanego do wysyłki wiadomości.": "Data for server used to send messages.",
        "Dane techniczne": "Technical data",
        "Dane widoczne w wiadomościach wysyłanych z panelu.": "Data visible in messages sent from panel.",
        "Dane wykorzystania limitu są prezentowane automatycznie, gdy źródło usług AI jest dostępne.": "Limit usage data are displayed automatically when AI service source is available.",
        "Dashboard": "Dashboard",
        "Dashboard aktywny": "Active dashboard",
        "Dashboard domyślny": "Default dashboard",
        "Dashboard został dodany.": "Dashboard has been added.",
        "Dashboard został skopiowany.": "Dashboard has been copied.",
        "Dashboard został usunięty.": "Dashboard has been deleted.",
        "Dashboard został zaktualizowane.": "Dashboard has been updated.",
        "Dashboardy": "Dashboards",
        "Data": "Date",
        "Data do": "Date to",
        "Data dodania": "Date added",
        "Data modyfikacji": "Modification date",
        "Data od": "Date from",
        "Data rejestracji": "Registration date",
        "Data uruchomienia": "Run date",
        "Data usunięcia": "Deletion date",
        "Data wylogowania": "Logout date",
        "Data zalogowania": "Login date",
        "Data zdarzenia": "Event date",
        "DateTime": "DateTime",
        "Dlaczego to problem": "Why this is a problem",
        "Długość historii haseł": "Password history length",
        "dni": "days",
        "Dni": "Days",
        "Dni tygodnia": "Days of week",
        "Do": "To",
        "do %0 MB": "up to %0 MB",
        "Do akceptacji": "For approval",
        "do czasu ręcznego odblokowania": "until manually unlocked",
        "Do filmu można dodać jedną ścieżkę napisów w formacie .vtt.": "You can add one subtitle track in .vtt format to a video.",
        "Do lewej": "Left",
        "Do prawej": "Right",
        "Do środka": "Center",
        "Do tej daty użytkownik nie może się zalogować. Puste pole oznacza brak blokady.": "User cannot log in until this date. Leave field empty for no restriction.",
        "Dobre": "Good",
        "Dodaj": "Add",
        "Dodaj aplikację uwierzytelniającą, aby generować kody bez dostępu do skrzynki e-mail.": "Add an authenticator app to generate codes without access to your email inbox.",
        "Dodaj dashboard": "Add dashboard",
        "Dodaj dostawcę": "Add provider",
        "Dodaj filtr": "Add filter",
        "Dodaj kolejne": "Add another",
        "Dodaj kolejne pliki": "Add more files",
        "Dodaj kolumnę": "Add column",
        "Dodaj kolumny": "Add columns",
        "Dodaj komórki TH w pierwszym wierszu albo przebuduj tabelę.": "Add TH cells in first row or rebuild table.",
        "Dodaj krótki opis tego, co obraz wnosi do treści. Dla dekoracji zostaw pusty alt tylko wtedy, gdy komponent na to świadomie pozwala.": "Add a short description of what image contributes to content. For decorative images, leave alt empty only if component explicitly allows it.",
        "Dodaj model": "Add model",
        "Dodaj nofollow": "Add nofollow",
        "Dodaj opis alternatywny dla obrazka.": "Add alt text for image.",
        "Dodaj osobne grafiki dla wybranych szerokości ekranu. Presety przyspieszają pracę, a własny breakpoint pozwala wpisać dowolną wartość. Każdy wariant może mieć też własne wymiary HTML.": "Add separate images for selected screen widths. Presets speed up work, and custom breakpoint lets you enter any value. Each variant can also have its own HTML dimensions.",
        "Dodaj pierwszy widget, a następnie ułóż go na siatce metodą przeciągnij i upuść.": "Add first widget, then arrange it on grid using drag and drop.",
        "Dodaj pliki": "Add files",
        "Dodaj pliki albo przeciągnij je tutaj.": "Add files or drag them here.",
        "Dodaj preset": "Add preset",
        "Dodaj preset, jeśli chcesz szybko ustawić popularny breakpoint, albo wpisz własną szerokość ekranu w pikselach.": "Add a preset to quickly set a popular breakpoint, or enter a custom screen width in pixels.",
        "Dodaj rolę": "Add role",
        "Dodaj sekcję": "Add section",
        "Dodaj stop": "Add stop",
        "Dodaj tekst linku albo usuń pusty link.": "Add link text or delete empty link.",
        "Dodaj uprawnienia": "Add privileges",
        "Dodaj urządzenie": "Add device",
        "Dodaj urządzenie uwierzytelniające": "Add authenticator device",
        "Dodaj użytkownika": "Add user",
        "Dodaj widget": "Add widget",
        "Dodaj własną proporcję": "Add custom aspect ratio",
        "Dodaj własny breakpoint": "Add custom breakpoint",
        "Dodaj zastępstwo w module Zastępstwa lub zmień miesiąc w filtrze listy.": "Add substitution in Substitutions module or change month in list filter.",
        "Dodaje delikatne tło co drugiemu wierszowi, więc łatwiej śledzić dane poziomo.": "Adds a subtle background to every other row, making it easier to follow data horizontally.",
        "dodał": "added",
        "dodane": "added",
        "Dodane": "Added",
        "Dodanie": "Adding",
        "Dodanie dashboardu": "Adding dashboard",
        "Dodanie roli": "Adding role",
        "Dodanie użytkownika": "Adding user",
        "Dodanie znaku wodnego": "Adding watermark",
        "dodano": "added",
        "Dodano": "Added",
        "dodany": "added",
        "Dodatkowe": "Additional",
        "Dodatkowe informacje przypisane do Twojego profilu.": "Additional information assigned to your profile.",
        "Dodatkowy krok przy logowaniu do panelu.": "Additional step when logging in to panel.",
        "Dodatkowy opis treści lub przeznaczenia pliku.": "Additional description of content or file purpose.",
        "Dodawanie plików do kolejki": "Adding files to queue",
        "Dokument": "Document",
        "Dokument ma załączniki": "Document has attachments",
        "Dokument PDF": "PDF document",
        "Dokument Studio": "Document Studio",
        "Dokument tekstowy": "Text document",
        "Dół": "Bottom",
        "Dołącz": "Attach",
        "Dołącz dokument Studio": "Attach Document Studio",
        "Dołącz pliki": "Attach files",
        "Dołącz stack trace": "Attach stack trace",
        "Dołącz zasób (dokument lub plik)": "Attach resource (document or file)",
        "Dołącza identyfikator i podstawowe dane użytkownika do zdarzenia.": "Adds user ID and basic details to event.",
        "Dołącza pełny stos wywołań do raportu błędu.": "Adds full stack trace to error report.",
        "Domyślna": "Default",
        "Domyślna ścieżka napisów": "Default subtitle path",
        "Domyślne": "Default",
        "Domyślnie": "Default",
        "Domyślny": "Default",
        "Domyślny dashboard jest otwierany użytkownikom jako pierwszy.": "Default dashboard is opened first for users.",
        "Domyślny poziom logowania": "Default logging level",
        "Dopasowanie miniatur": "Thumbnail fit",
        "Dopasuj miniaturę – pokaż cały obraz": "Fit thumbnail – show entire image",
        "Dostawca": "Provider",
        "Dostawcy": "Providers",
        "Dostęp": "Access",
        "Dostęp do panelu będzie ograniczony do podanych adresów. Wpisz adresy po przecinku.": "Access to panel will be limited to specified addresses. Enter addresses separated by commas.",
        "Dostęp niezdefiniowany": "Access undefined",
        "Dostępna jest nowa aktualizacja": "A new update is available",
        "Dostępne akcje:": "Available actions:",
        "Dostępne ikony": "Available icons",
        "Double": "Double",
        "Dowolne": "Any",
        "dowolny": "any",
        "Dozwolone": "Allowed",
        "Dozwolone są wyłącznie pliki JPEG i PNG.": "Only JPEG and PNG files are allowed.",
        "Dozwolone typy: image/jpeg, image/png · max %0 MB": "Allowed types: image/jpeg, image/png · max %0 MB",
        "Drzewo": "Tree",
        "Dsn": "Dsn",
        "Duże litery": "Uppercase",
        "Duże rzymskie": "Uppercase Roman",
        "Duży układ siatki": "Large grid layout",
        "Działania dla zaznaczonych elementów": "Actions for selected items",
        "Działania dla zaznaczonych elementów kosza": "Actions for selected bin items",
        "Dziedzicz - z ról / domyślne": "Inherit - from roles / default",
        "Dziedziczone": "Inherited",
        "dzień": "day",
        "Dziennik zdarzeń": "Event log",
        "Dziś": "Today",
        "Dzisiaj": "Today",
        "E-mail": "E-mail",
        "E-mail potwierdzony": "Email confirmed",
        "Edito": "Edito",
        "Edycja aranżacji - podgląd układu na danych demonstracyjnych": "Edit layout - preview layout with sample data",
        "Edycja aranżacji dashboardu": "Dashboard arrangement edit",
        "Edycja Crona · {name}": "Edit Cron · {name}",
        "Edycja dashboardu": "Dashboard edit",
        "Edycja i publikacja treści": "Editing and publishing content",
        "Edycja logów": "Logs edit",
        "Edycja obrazu": "Edit image",
        "Edycja roli": "Role edit",
        "Edycja uprawnień": "Edit privileges",
        "Edycja użytkownika": "User edit",
        "Edycja zaznaczonych": "Edit selected",
        "Edytor kodu": "Code editor",
        "Edytor kodu HTML": "HTML code editor",
        "Edytor treści": "Content editor",
        "Edytor treści · pełny ekran": "Content editor · full screen",
        "Edytuj": "Edit",
        "Edytuj aranżację": "Edit layout",
        "Edytuj filtr": "Edit filter",
        "Edytuj link": "Edit link",
        "Edytuj uprawnienia": "Edit privileges",
        "Edytuj wiadomość": "Edit message",
        "Ekran jest zbyt wąski": "Screen is too narrow",
        "Eksport": "Export",
        "Eksport śladów, metryk i logów do zewnętrznej platformy monitorującej.": "Export traces, metrics, and logs to external monitoring platform.",
        "Eksportuj przefiltrowanych": "Export filtered",
        "Eksportuj wszystkich": "Export all",
        "Element został przywrócony.": "Item has been restored.",
        "Element został trwale usunięty.": "Item has been permanently deleted.",
        "Elementów na stronie": "Items per page",
        "Elementy": "Items",
        "Embedding": "Embedding",
        "Embeddingi do wyszukiwania semantycznego.": "Embeddings for semantic search.",
        "Emoji": "Emoji",
        "Endpoint": "Endpoint",
        "Esc – zamknij podgląd": "Esc – close preview",
        "Etap": "Stage",
        "Etap przetwarzania wiadomości": "Message processing stage",
        "Etap wykonania zadania": "Task execution stage",
        "Etykieta napisów": "Subtitle label",
        "Etykiety": "Labels",
        "False": "False",
        "Filtr": "Filter",
        "Filtr widgetu": "Widget filter",
        "Filtr zmian": "Change filter",
        "Filtr został usunięty": "Filter has been deleted",
        "Filtry": "Filters",
        "Filtry listy": "List filters",
        "Filtry wyszukiwania": "Search filters",
        "Folder": "Folder",
        "Folder docelowy": "Destination folder",
        "Folder główny": "Main folder",
        "Folder plików": "File folder",
        "Folderów nie można wstawić w tym miejscu.": "Folders cannot be inserted here.",
        "Foldery": "Folders",
        "Format obrazów": "Image format",
        "Format zapisu": "Save format",
        "Formatowanie": "Formatting",
        "Formularz": "Form",
        "Fotografia": "Photography",
        "Fragment odpowiedzi": "Response excerpt",
        "Gdy przycisk pobrania zniknął": "When download button disappears",
        "Generowanie obrazów": "Image generation",
        "Generowanie obrazów zakończone": "Image generation complete",
        "Generowanie obrazu AI": "AI image generation",
        "Generowanie, edycja i modyfikacja obrazów oraz grafik": "Image and graphic generation, editing and modification",
        "Generuj": "Generate",
        "Generuj hasło": "Generate password",
        "Generuj kod QR": "Generate QR code",
        "Generuj metadane": "Generate metadata",
        "Generuj obraz": "Generate image",
        "Globalna polityka 2FA": "Global 2FA policy",
        "Globalny": "Global",
        "godz.": "hrs.",
        "Godziny": "Hours",
        "Google Authenticator, Microsoft Authenticator lub podobna aplikacja TOTP.": "Google Authenticator, Microsoft Authenticator, or similar TOTP app.",
        "Góra": "Top",
        "Gotowe": "Done",
        "gotowy do pracy": "ready to work",
        "Gradient": "Gradient",
        "Grafana Cloud": "Grafana Cloud",
        "Grubość ramki": "Border thickness",
        "grudzień": "December",
        "Grupa": "Group",
        "Grupuje powiązane usługi w platformie monitorującej.": "Groups related services in monitoring platform.",
        "Grupy zmian": "Change groups",
        "Harmonogram jest wykonywany według czasu UTC.": "Schedule runs according to UTC time.",
        "Harmonogram zadań": "Task schedule",
        "Harmonogram został zmieniony": "Schedule has been changed",
        "Hasła": "Passwords",
        "Hasła nie są identyczne.": "Passwords do not match.",
        "Hasło": "Password",
        "Hasło lub klucz aplikacji dla tego konta.": "Password or app key for this account.",
        "Hasło musi zawierać co najmniej jeden znak specjalny, np.: ~ @ # $ % ^ & *": "Password must contain at least one special character, e.g.: ~ @ # $ % ^ & *",
        "Hasło zostało skopiowane.": "Password has been copied.",
        "Hasło zostało zmienione. Zaloguj się ponownie": "Password has been changed. Log in again",
        "high": "high",
        "Historia logowania": "Login history",
        "Historia rozmów": "Conversation history",
        "Historia rozmów została wyczyszczona.": "Conversation history has been cleared.",
        "Historia sesji": "Session history",
        "Historia wersji": "Version history",
        "Historia wersji ({count})": "Version history ({count})",
        "Historia zadania": "Task history",
        "Host": "Host",
        "href=\"#\" zwykle jest placeholderem zostawionym po szkicu treści. Na stronie może przewijać użytkownika do góry albo nie robić nic.": "href=\"#\" is usually a placeholder left over from a content draft. On a page, it may scroll the user to the top or do nothing.",
        "i": "and",
        "Id": "Id",
        "ID": "ID",
        "ID lub typ zadania": "ID or task type",
        "Id modelu": "Model ID",
        "Id obiektu": "Object ID",
        "Id sesji": "Session ID",
        "ID zadania": "Task ID",
        "Identyfikator aplikacji Microsoft Entra.": "Microsoft Entra application ID.",
        "Identyfikator dzierżawy Microsoft 365.": "Microsoft 365 tenant ID.",
        "Identyfikator modelu po stronie dostawcy.": "Model identifier on the provider side.",
        "Identyfikator zadania": "Task identifier",
        "Ignoruj szybkie zapytania SQL": "Ignore fast SQL queries",
        "Ikona chmury, płaska ilustracja wektorowa": "Cloud icon, flat vector illustration",
        "Ikona filtra": "Filter icon",
        "Ile ostatnich haseł nie może zostać ponownie użytych (0 = bez ograniczeń).": "How many previous passwords cannot be reused (0 = no limit).",
        "Im więcej szczegółów – kompozycja, światło, nastrój – tym lepszy wynik.": "More details—composition, lighting, mood—produce a better result.",
        "Imię": "First name",
        "Imię i nazwisko": "First and last name",
        "Imię i nazwisko autora lub nazwa twórcy materiału.": "Name of author or creator of material.",
        "Import użytkowników": "User import",
        "Indeks dolny": "Subscript",
        "Indeks górny": "Superscript",
        "Indywidualne": "Individual",
        "Informacje": "Information",
        "Informacje o typie konta i ostatnim logowaniu.": "Information about account type and last login.",
        "Informacje o zdarzeniu": "Event information",
        "Inspekcja": "Inspection",
        "Inspekcja będzie dostępna po zapisaniu konta.": "Inspection will be available after saving account.",
        "Inspekcja nie zwróciła szczegółowych wpisów uprawnień.": "Inspection returned no detailed privilege entries.",
        "Inspekcja uprawnień": "Privilege inspection",
        "Instalacja": "Installation",
        "Int": "Int",
        "Interlinia": "Line spacing",
        "Jak długo konto pozostaje zablokowane przed kolejną próbą.": "How long account remains locked before another attempt.",
        "Jak korzystać na co dzień": "How to use it day to day",
        "Jakość": "Quality",
        "Jakość obrazu": "Image quality",
        "Jasność": "Brightness",
        "Jeśli program zapyta, zatwierdź zaufanie do projektu i połączenie z serwerem „edito”.": "If prompted, approve trust for project and connection to “edito” server.",
        "Jeśli program zapyta, zatwierdź zaufanie do projektu i serwera „edito”.": "If prompted, approve trust for project and “edito” server.",
        "Jeśli zostawisz szerokość pustą, wyrównanie użyje naturalnej szerokości tabeli.": "If you leave width blank, alignment will use natural table width.",
        "Język": "Language",
        "Język bloku kodu": "Code block language",
        "Język interfejsu panelu dla tego użytkownika.": "Panel interface language for this user.",
        "Język napisów": "Subtitle language",
        "Język zakresu": "Scope language",
        "Kadr. Strzałki przesuwają, Alt i strzałki zmieniają rozmiar. Shift zwiększa krok.": "Crop. Arrow keys move; Alt and arrow keys resize. Shift increases step size.",
        "Kadrowanie": "Cropping",
        "Kadrowanie obrazu": "Image cropping",
        "kadrowanie, transformacje, filtry, znak wodny i eksport": "cropping, transformations, filters, watermark, and export",
        "Kalendarz - Kategorie zasobów": "Calendar - Resource categories",
        "Katalog został utworzony": "Catalog has been created",
        "Kategorie": "Categories",
        "Kategorie powiadomień": "Notification categories",
        "Kategorie widżetów": "Widget categories",
        "Każdy": "Each",
        "Każdy układ wstawi gotową strukturę z przykładową zawartością, którą możesz od razu nadpisać.": "Each layout inserts a ready-made structure with sample content that you can overwrite right away.",
        "Klasy CSS": "CSS classes",
        "Klienci": "Clients",
        "Kliknij „Utwórz token”. Po udanym zapisie pozostaw okno otwarte: pojawi się token i sekcja „Połącz Edito z asystentem AI”, potrzebna w następnym kroku.": "Click “Create token”. After saving successfully, leave window open: token and “Connect Edito to AI assistant” section will appear, needed in next step.",
        "Klucz API": "API key",
        "Klucz prywatny": "Private key",
        "Klucz publiczny": "Public key",
        "Klucz został skopiowany.": "Key has been copied.",
        "Klucze nie są poprawne": "Keys are invalid",
        "Klucze są nieprawidłowe.": "Keys are invalid.",
        "Klucze są poprawne": "Keys are valid",
        "Klucze są prawidłowe.": "Keys are valid.",
        "Kod C#": "C# code",
        "Kod CSS": "CSS code",
        "Kod do osadzenia": "Embed code",
        "Kod HTML": "HTML code",
        "Kod JavaScript": "JavaScript code",
        "Kod jednorazowy": "One-time code",
        "Kod jednorazowy wysyłamy na Twój adres e-mail przy każdym logowaniu.": "We send a one-time code to your email address each time you log in.",
        "Kod jest nieprawidłowy lub konfiguracja wygasła. Spróbuj ponownie.": "Code is invalid or configuration has expired. Try again.",
        "Kod QR jest gotowy. Zeskanuj go w aplikacji uwierzytelniającej.": "QR code is ready. Scan it with your authenticator app.",
        "Kod QR konfiguracji aplikacji uwierzytelniającej": "Authenticator app setup QR code",
        "Kod TypeScript": "TypeScript code",
        "Kod Vue (Single-File Component)": "Vue code (Single-File Component)",
        "Kod weryfikacyjny": "Verification code",
        "Kod weryfikacyjny jest nieprawidłowy lub wygasł.": "Verification code is invalid or has expired.",
        "Kod weryfikacyjny jest nieprawidłowy.": "Verification code is invalid.",
        "Kod z wiadomości został potwierdzony. Nadaj nowe hasło do konta.": "Code from message has been confirmed. Set a new password for your account.",
        "Kod zmienia się co 30 sekund. Upewnij się, że czas na urządzeniu jest prawidłowy.": "Code changes every 30 seconds. Make sure time on your device is correct.",
        "Kod źródłowy": "Source code",
        "Kohorta": "Cohort",
        "Kolejka": "Queue",
        "Kolejka wysyłania": "Sending queue",
        "Koło": "Circle",
        "Kolor": "Color",
        "Kolor tekstu": "Text color",
        "Kolor tła": "Background color",
        "Kolor widżetu": "Widget color",
        "Kolor wyróżnia ikonę i linię pod nagłówkiem.": "Color highlights icon and line below heading.",
        "Kolumny": "Columns",
        "Komentarz": "Comment",
        "Komponent React": "React component",
        "Komunikat": "Message",
        "Kończę odpowiedź...": "I'm finishing the answer...",
        "Konfiguracja": "Configuration",
        "Konfiguracja AI": "AI configuration",
        "Konfiguracja dashboardu": "Dashboard configuration",
        "Konfiguracja harmonogramu (czas UTC)": "Schedule configuration (UTC time)",
        "Konfiguracja krok po kroku": "Step-by-step configuration",
        "Konfiguracja modułu Studio": "Studio module configuration",
        "Konfiguracja została zmieniona.": "Configuration has been changed.",
        "Konsola aplikacji": "Application console",
        "Konsola aplikacji nigdy nie rejestruje logów z poniższych przestrzeni nazw:": "Application console never logs from the following namespaces:",
        "Konta użytkowników zostały odblokowane": "User accounts have been unlocked",
        "Konta użytkowników zostały usunięte z systemu": "User accounts have been removed from the system",
        "Konta użytkowników zostały zablokowane": "User accounts have been locked",
        "Kontakty - Typ działania": "Contacts - Action type",
        "Konto": "Account",
        "Konto aktywne": "Active account",
        "Konto pozostanie nieaktywne, dopóki adres e-mail nie zostanie potwierdzony.": "Account will remain inactive until email address is confirmed.",
        "Konto z dostępem do panelu": "Account with access to panel",
        "Konto zanonimizowane": "Account anonymized",
        "Konto, z którego wysyłana jest poczta.": "Account used to send email.",
        "Kontrast": "Contrast",
        "Kontrolowany": "Controlled",
        "Kopiuj": "Copy",
        "Kopiuj hasło": "Copy password",
        "Kopiuj identyfikator rozmowy": "Copy conversation identifier",
        "Kopiuj klucz": "Copy key",
        "Kopiuj link": "Copy link",
        "Kopiuj odpowiedź": "Copy answer",
        "Kopiuj pole": "Copy field",
        "Kopiuj polecenie": "Copy command",
        "Korzystasz z właściwego panelu i tokenu opisanego swoim imieniem i nazwiskiem.": "You're using the correct panel and a token labeled with your first and last name.",
        "Kosz": "Bin",
        "Kosz został opróżniony.": "Bin has been emptied.",
        "Kotwica": "Anchor",
        "Krój czcionki": "Font",
        "Kroki konfiguracji MCP": "MCP setup steps",
        "kroków": "steps",
        "Kropki": "Dots",
        "Krótki opis obrazu…": "Brief image description…",
        "Krótki opis ułatwia rozpoznanie przeznaczenia dashboardu.": "A brief description makes it easier to identify dashboard's purpose.",
        "Krótki opis zawartości obrazu, odczytywany przez czytniki ekranu.": "Brief description of image content, read by screen readers.",
        "Krótko, czego dotyczy ten dashboard…": "Briefly describe what this dashboard is about…",
        "Kursywa": "Italic",
        "Kwadraty": "Squares",
        "kwiecień": "April",
        "Ładowanie": "Loading",
        "Ładowanie logo witryn...": "Loading site logos...",
        "Ładowanie obrazu...": "Loading image...",
        "Laptop na biurku, minimalistyczna kompozycja": "Laptop on desk, minimalist composition",
        "lat": "years",
        "lata": "years",
        "Lawendowy": "Lavender",
        "Legenda": "Legend",
        "Lewo": "Left",
        "Lewy dolny": "Bottom left",
        "Lewy górny": "Top left",
        "Lewy panel": "Left panel",
        "Licencja": "License",
        "Liczba": "Number",
        "Liczba nieudanych prób logowania, po której konto zostaje zablokowane.": "Number of failed login attempts after which account is locked.",
        "Liczba obrazów": "Number of images",
        "Licznik kolejnych błędnych prób logowania.": "Counter for consecutive failed login attempts.",
        "Limonkowy": "Lime",
        "Linia": "Line",
        "Linia pozioma": "Horizontal line",
        "Linie": "Lines",
        "Link": "Link",
        "Link bez adresu": "Link without an address",
        "Link bez adresu wygląda jak aktywny element, ale nie prowadzi użytkownika do celu.": "A link without an address looks like an active element but doesn't take user anywhere.",
        "Link bez tekstu": "Link without text",
        "Link do admina": "Link to admin panel",
        "Link do dokumentu": "Link to document",
        "Link skopiowany do schowka.": "Link copied to clipboard.",
        "Link w treści publicznej nie powinien prowadzić do panelu.": "A link in public content shouldn't lead to admin panel.",
        "Link z href=\"#\"": "Link with href=\"#\"",
        "Lint nie znalazł problemów w tej treści.": "Lint found no issues in this content.",
        "Lint treści": "Content lint",
        "lipiec": "July",
        "Lista kontrolna": "Checklist",
        "Lista miejsc użycia została ograniczona.": "List of usage locations has been limited.",
        "Lista nie zawiera jeszcze żadnych elementów.": "List doesn't contain any items yet.",
        "Lista numerowana": "Numbered list",
        "Lista punktowana": "Bulleted list",
        "Lista rozmów jest teraz niedostępna. Spróbuj pobrać ją ponownie. Jeśli problem się powtarza, sprawdź połączenie z siecią lub spróbuj później.": "Conversation list is currently unavailable. Try loading it again. If problem persists, check your network connection or try again later.",
        "Lista rozmów odświeżona": "Conversation list refreshed",
        "Lista rozmów została pobrana. Możesz wybrać rozmowę z panelu historii.": "Conversation list has been loaded. You can select a conversation from history panel.",
        "Lista zaufanych adresów IP": "Trusted IP address list",
        "listopad": "November",
        "Listy": "Lists",
        "Log zadania został skopiowany.": "Task log copied.",
        "Logi poniżej tego poziomu nie będą zbierane niezależnie od pozostałych ustawień.": "Logs below this level won't be collected regardless of other settings.",
        "Logi wydajnościowe": "Performance logs",
        "Login do panelu, unikalny w całej instancji.": "Panel login, unique across entire instance.",
        "Logo": "Logo",
        "Logo witryny": "Site logo",
        "Logowanie": "Login",
        "Logowanie nazwą użytkownika i hasłem.": "Login with username and password.",
        "Logowanie zakończyło się niepowodzeniem.": "Login failed.",
        "Logowanie zdarzeń": "Event logging",
        "Lokalizacja": "Location",
        "Lokalne": "Local",
        "Long": "Long",
        "low": "low",
        "Low‑poly": "Low-poly",
        "Lub wybierz zakres": "Or select a range",
        "luty": "February",
        "macOS: w folderze „Pobrane” kliknij ZIP dwukrotnie.": "macOS: double-click ZIP file in “Downloads” folder.",
        "maj": "May",
        "Maksymalna rozdzielczość: %0 × %1 px.": "Maximum resolution: %0 × %1 px.",
        "Maksymalna szerokość ekranu (px)": "Maximum screen width (px)",
        "Maksymalny czas trwania zapytania uznawanego za szybkie (ms)": "Maximum duration of a request considered fast (ms)",
        "Maksymalny rozmiar jednego pliku to 20 MB.": "Maximum file size is 20 MB.",
        "Małe litery": "Lowercase letters",
        "Małe rzymskie": "Lowercase Roman numerals",
        "Malejąco": "Descending",
        "Mały układ siatki": "Small grid layout",
        "Margines dolny": "Bottom margin",
        "Margines górny": "Top margin",
        "marzec": "March",
        "Masz niezapisane zmiany.": "You have unsaved changes.",
        "Materiały dodatkowe": "Additional materials",
        "Media": "Media",
        "medium": "medium",
        "Medium": "Medium",
        "Menu": "Menu",
        "Menu konta": "Account menu",
        "Menu kontekstowe edytora": "Editor context menu",
        "Menu: %0": "Menu: %0",
        "Metadane pliku": "File metadata",
        "Metoda autentykacji": "Authentication method",
        "Metoda weryfikacji": "Verification method",
        "Microsoft Aspire": "Microsoft Aspire",
        "mies.": "mo.",
        "Miesiąc": "Month",
        "Miesiące": "Months",
        "Mieszane": "Mixed",
        "Miętowy": "Mint",
        "min": "min",
        "min. 8 znaków": "min. 8 characters",
        "Miniatura artykułu {title}": "Article thumbnail {title}",
        "Minimalizuj": "Minimize",
        "Minimalna długość hasła": "Minimum password length",
        "Minuty": "Minutes",
        "Mocniejsze obramowanie": "Heavier border",
        "Model": "Model",
        "Model użyty przez panel dla każdego rodzaju zadania.": "Model used by the admin panel for each type of task.",
        "Modele": "Models",
        "Modele pochodzą z konfiguracji wybranego dostawcy.": "Models come from the selected provider configuration.",
        "Modele udostępnione w panelu wraz z ich możliwościami.": "Models available in the admin panel with their capabilities.",
        "Moduł": "Module",
        "Modyfikacja": "Modification",
        "Modyfikacja obrazu przed wysłaniem": "Image editing before upload",
        "Modyfikuj obrazy przed wysłaniem": "Edit images before upload",
        "Moje": "My",
        "Moje pliki": "My files",
        "Monitor kolejek": "Queue monitor",
        "Monitoring": "Monitoring",
        "Monitoring aplikacji": "Application monitoring",
        "Monitorowane adresy URL dla żądań HTTP": "URLs monitored for HTTP requests",
        "Monitoruj bazy danych (SQL, Redis, ElasticSearch)": "Monitor databases (SQL, Redis, ElasticSearch)",
        "Monitoruj statystyki .NET": ".NET statistics monitoring",
        "Monitoruj żądania HTTP": "HTTP request monitoring",
        "Morelowy": "Apricot",
        "Możesz dołączyć maksymalnie {0} zasobów.": "You can attach up to {0} assets.",
        "Możesz dołączyć maksymalnie 4 pliki.": "You can attach up to 4 files.",
        "Możesz dołączyć obrazy oraz pliki PDF, DOCX, XLSX, TXT, MD i CSV.": "You can attach images and PDF, DOCX, XLSX, TXT, MD, and CSV files.",
        "Możesz przeciągnąć tutaj kolejne pliki": "You can drag more files here",
        "Możesz wybrać maksymalnie %0 plików.": "You can select up to %0 files.",
        "Możliwość modyfikacji tego konta jest ograniczona. Nieaktywne pola są sychronizowane z zewnętrzną bazą danych %0.": "Modification of this account is limited. Inactive fields are synchronized with external database %0.",
        "Możliwość modyfikacji tego konta jest ograniczona. Nieaktywne pola są synchronizowane z zewnętrzną bazą danych %0.": "Modification of this account is limited. Inactive fields are synchronized with external database %0.",
        "Możliwość zmiany hasła jest zablokowana. Obsługa hasła znajduje się po stronie zewnętrznej bazy danych %0.": "Changing password is disabled. Password management is handled by external database %0.",
        "Możliwości": "Capabilities",
        "Możliwości wybranego modelu": "Selected model capabilities",
        "Mroczne fantasy": "Dark fantasy",
        "Multimedia": "Multimedia",
        "Na liście tokenów kliknij „Dodaj token”. W otwartym oknie znajdziesz formularz nowego połączenia.": "In the token list, click “Add token”. In the window that opens, you will find a form for a new connection.",
        "Na ten adres trafi wiadomość testowa.": "A test message will be sent to this address.",
        "Naciśnij spację lub Enter, aby podnieść widget. Użyj strzałek oraz klawiszy Home i End, następnie naciśnij spację lub Enter, aby zatwierdzić. Escape anuluje zmianę.": "Press Space or Enter to lift the widget. Use the arrow keys, Home, and End, then press Space or Enter to confirm. Escape cancels the change.",
        "Nadaj roli nazwę i określ sposób jej przypisywania.": "Name the role and specify how it is assigned.",
        "Nadane bezpośrednio": "Assigned directly",
        "Nadawca": "Sender",
        "Nagłówek": "Header",
        "Nagłówek dostaje ciemne tło i mocniejszy kontrast, więc od razu odróżnia się od danych.": "Header has a dark background and higher contrast, so it stands out from the data.",
        "Nagłówek komórki": "Cell header",
        "Nagłówki HTTP": "HTTP headers",
        "Najczęściej 587 lub 465.": "Usually 587 or 465.",
        "Najczęstsze problemy": "Common issues",
        "Najkrótsze hasło, jakie użytkownik może ustawić.": "Shortest password a user can set.",
        "Najpierw ustaw obraz główny.": "Set the main image first.",
        "Najpierw zapisz wprowadzone zmiany": "Save your changes first",
        "Napisy WebVTT": "WebVTT captions",
        "Napisz wiadomość...": "Write a message...",
        "Narzędzia": "Tools",
        "Następna strona": "Next page",
        "Następne trafienie": "Next match",
        "Następny miesiąc": "Next month",
        "Następny plik": "Next file",
        "Następny rok": "Next year",
        "Nasycenie": "Saturation",
        "Natychmiast przywraca domyślny harmonogram zadania i zapisuje tę zmianę. Zamyka okno bez potrzeby klikania „Zapisz”.": "Immediately restores the task's default schedule and saves this change. Closes the window without needing to click “Save”.",
        "Nawigacja mobilna": "Mobile navigation",
        "Nazwa": "Name",
        "Nazwa będzie widoczna na liście dashboardów i w nagłówku widoku.": "Name will be visible in dashboard list and in view header.",
        "Nazwa dashboardu": "Dashboard name",
        "Nazwa identyfikująca aplikację w narzędziu monitorującym.": "Name identifying application in monitoring tool.",
        "Nazwa katalogu": "Directory name",
        "Nazwa katalogu została zmieniona.": "Folder name has been changed.",
        "Nazwa licencji lub informacja o prawach do wykorzystania materiału.": "License name or information about rights to use material.",
        "Nazwa nadawcy": "Sender name",
        "Nazwa nowego pliku": "New file name",
        "Nazwa nowych plików": "New file names",
        "Nazwa pliku": "File name",
        "Nazwa pliku została zmieniona.": "File name has been changed.",
        "Nazwa pola": "Field name",
        "Nazwa roli": "Role name",
        "Nazwa rozmowy": "Conversation name",
        "Nazwa typu": "Type name",
        "Nazwa urządzenia": "Device name",
        "Nazwa urządzenia została zmieniona.": "Device name has been changed.",
        "Nazwa usługi": "Service name",
        "Nazwa użytkownika": "Username",
        "Nazwa używana do logowania i identyfikacji konta.": "Name used to log in and identify account.",
        "Nazwa widoczna na liście ról i w ustawieniach użytkownika.": "Name visible in role list and user settings.",
        "Nazwa widoczna przy wyborze modelu dla zadań.": "Name displayed when selecting a model for tasks.",
        "Nazwa widoczna w nagłówku widżetu.": "Name visible in widget header.",
        "Nazwa wyświetlana": "Display name",
        "Nazwa wyświetlana w aplikacji uwierzytelniającej": "Name displayed in authenticator app",
        "Nazwa zadania": "Task name",
        "Nazwa zestawu": "Set name",
        "nazwa-kotwicy": "anchor-name",
        "Nazwij połączenie i określ ważność dostępu.": "Name the connection and specify access validity.",
        "Nazwij urządzenie, zeskanuj kod QR i potwierdź kodem z aplikacji.": "Name the device, scan the QR code, and confirm with a code from the app.",
        "Nazwisko": "Last name",
        "Nie": "No",
        "Nie dodano jeszcze wariantów responsywnych": "No responsive variants have been added yet",
        "Nie dotyczy plików SVG i ICO.": "Does not apply to SVG and ICO files.",
        "Nie jesteś zalogowany albo sesja straciła ważność.\nZaloguj się ponownie, aby wrócić do panelu.": "You are not logged in or your session has expired.\nLog in again to return to the dashboard.",
        "Nie ma dostępnych kluczy do wstawienia w treści.": "No keys are available to insert into the content.",
        "Nie ma zapisanych wpisów uprawnień do wyświetlenia.": "There are no saved privilege entries to display.",
        "Nie masz jeszcze ostatnio używanych emoji.": "You don't have any recently used emoji yet.",
        "Nie masz uprawnień do panelu administracyjnego.": "You do not have privileges to the admin panel.",
        "Nie masz uprawnień do tego widoku. Stan widoku mógł ulec zmianie, odśwież i sprawdź lub spróbuj ponownie później.": "You do not have privileges to this view. View state may have changed, refresh and check or try again later.",
        "Nie możesz modyfikować profilu zastępowanego użytkownika.": "You cannot modify the profile of the substituted user.",
        "Nie możesz modyfikować uprawnień": "You cannot modify privileges",
        "Nie możesz usunąć jedynego urządzenia, gdy aktywna metoda 2FA to Aplikacja uwierzytelniająca. Przełącz na metodę Email, aby móc usunąć to urządzenie.": "You cannot delete the only device while the Authenticator app is the active 2FA method. Switch to Email to delete this device.",
        "Nie możesz usunąć jedynego urządzenia, gdy aktywna metoda 2FA to Aplikacja uwierzytelniająca. Wyłącz 2FA lub przełącz na metodę Email, aby móc usunąć to urządzenie.": "You cannot delete the only device while the Authenticator app is the active 2FA method. Turn off 2FA or switch to Email to delete this device.",
        "Nie możesz usunąć jedynego urządzenia, gdy weryfikacja przez aplikację uwierzytelniającą jest wymagana przez system.": "You cannot delete the only device when verification through the authenticator app is required by the system.",
        "Nie można cofnąć tej zmiany.": "This change cannot be undone.",
        "Nie można dodać pliku \"%0\" z powodu: %1.": "Cannot add file \"%0\" because: %1.",
        "Nie można odczytać zapisanego zestawu.": "Cannot read saved set.",
        "Nie można usunąć swojego konta.": "Cannot delete your own account.",
        "Nie można wysłać kodu. Spróbuj zalogować się ponownie.": "Unable to send code. Try logging in again.",
        "Nie można wyświetlić podglądu pliku. Wybierz inny plik.": "Unable to preview file. Select another file.",
        "Nie można zainicjować konfiguracji. Spróbuj ponownie.": "Unable to initialize configuration. Try again.",
        "Nie pamiętam hasła": "I forgot my password",
        "Nie pokazuj tokenu ani plików konfiguracyjnych w rozmowach lub na zrzutach ekranu.": "Do not show token or configuration files in conversations or screenshots.",
        "Nie pomijaj poziomów nagłówków. Po H2 użyj H3, po H3 użyj H4 itd.": "Do not skip heading levels. After H2, use H3; after H3, use H4, etc.",
        "Nie przechowuj folderu we współdzielonym OneDrive, SharePoint ani na dysku sieciowym.": "Do not store the folder in a shared OneDrive, SharePoint, or network drive.",
        "Nie udało się — ponów": "Failed — try again",
        "Nie udało się cofnąć": "Failed to undo",
        "Nie udało się odtworzyć wybranych plików.": "Failed to restore selected files.",
        "Nie udało się otworzyć pliku w repozytorium.": "Failed to open file in repository.",
        "Nie udało się otworzyć rozmowy.": "Failed to open conversation.",
        "Nie udało się otworzyć strony": "Failed to open page",
        "Nie udało się pobrać danych ankiet.": "Failed to retrieve survey data.",
        "Nie udało się pobrać danych o użytkownikach.": "Failed to retrieve user data.",
        "Nie udało się pobrać danych produktowych.": "Failed to retrieve product data.",
        "Nie udało się pobrać danych z CMS.": "Failed to retrieve data from CMS.",
        "Nie udało się pobrać danych z Google Analytics.": "Failed to retrieve data from Google Analytics.",
        "Nie udało się pobrać danych z modułu dynamicznego.": "Failed to retrieve data from dynamic module.",
        "Nie udało się pobrać danych ze sklepu.": "Failed to retrieve data from store.",
        "Nie udało się pobrać dziennika.": "Failed to retrieve log.",
        "Nie udało się pobrać konfiguracji AI. Sprawdź połączenie i spróbuj ponownie.": "Failed to retrieve AI configuration. Check your connection and try again.",
        "Nie udało się pobrać konfiguracji dashboardu": "Failed to fetch dashboard configuration",
        "Nie udało się pobrać listy filtrów": "Failed to fetch filter list",
        "Nie udało się pobrać listy kolejek": "Failed to fetch queue list",
        "Nie udało się pobrać listy ról": "Failed to fetch role list",
        "Nie udało się pobrać listy typów modeli": "Failed to fetch model type list",
        "Nie udało się pobrać listy zastępstw.": "Failed to retrieve substitution list.",
        "Nie udało się pobrać miejsc użycia pliku.": "Failed to retrieve file usage locations.",
        "Nie udało się pobrać uprawnień użytkownika. Spróbuj ponownie.": "Failed to retrieve user privileges. Try again.",
        "Nie udało się pobrać wersji do porównania.": "Failed to retrieve versions for comparison.",
        "Nie udało się pobrać widżetów": "Failed to retrieve widgets",
        "Nie udało się połączyć z asystentem. Sprawdź połączenie sieciowe.": "Failed to connect to assistant. Check your network connection.",
        "Nie udało się przenieść plików.": "Failed to move files.",
        "Nie udało się przeszukać dokumentów": "Failed to search documents",
        "Nie udało się przygotować akcji — rozmowa została odświeżona.": "Failed to prepare action — conversation has been refreshed.",
        "Nie udało się skopiować dziennika.": "Failed to copy log.",
        "Nie udało się skopiować klucza. Skopiuj go ręcznie.": "Failed to copy key. Copy it manually.",
        "Nie udało się skopiować polecenia. Zaznacz i skopiuj tekst ręcznie.": "Failed to copy command. Select and copy text manually.",
        "Nie udało się ukończyć operacji": "Operation failed",
        "Nie udało się uruchomić asystenta.": "Failed to start assistant.",
        "Nie udało się usunąć rozmowy.": "Failed to delete conversation.",
        "Nie udało się usunąć szablonu": "Failed to delete template",
        "Nie udało się wczytać aranżacji dashboardu": "Failed to load dashboard layout",
        "Nie udało się wczytać opcji. Otwórz listę ponownie, aby spróbować jeszcze raz.": "Failed to load options. Reopen list to try again.",
        "Nie udało się wczytać ról": "Failed to load roles",
        "Nie udało się wczytać rozmów": "Failed to load conversations",
        "Nie udało się wczytać szczegółów zdarzenia.": "Failed to load event details.",
        "Nie udało się wczytać uprawnień": "Failed to load privileges",
        "Nie udało się wczytać uprawnień.": "Failed to load privileges.",
        "Nie udało się wczytać zawartości folderu.": "Failed to load folder contents.",
        "Nie udało się wczytać zestawów.": "Failed to load sets.",
        "Nie udało się wyczyścić historii rozmów.": "Failed to clear conversation history.",
        "Nie udało się wykonać edycji zaznaczonych obrazów.": "Failed to edit selected images.",
        "Nie udało się wykonać planu.": "Failed to execute plan.",
        "Nie udało się wysłać pliku": "Failed to send file",
        "Nie udało się wysłać pliku. Sprawdź połączenie.": "Failed to send file. Check your connection.",
        "Nie udało się zaktualizować zestawu.": "Failed to update set.",
        "Nie udało się załadować danych": "Failed to load data",
        "Nie udało się załadować elementów": "Failed to load items",
        "Nie udało się zapisać obrazu.": "Failed to save image.",
        "Nie udało się zapisać oceny.": "Failed to save rating.",
        "Nie udało się zapisać ustawień dashboardu": "Failed to save dashboard settings",
        "Nie udało się zapisać zestawu.": "Failed to save set.",
        "Nie udało się zmienić nazwy rozmowy.": "Failed to rename conversation.",
        "Nie udało się zmienić trybu działania.": "Failed to change operating mode.",
        "Nie udostępniaj paczki ani folderu innym osobom, również przez e-mail lub komunikator.": "Do not share the package or folder with anyone else, including by email or messaging app.",
        "Nie ustawiono tego uprawnienia. Dostęp może wynikać z innych przypisań.": "This privilege has not been set. Access may result from other assignments.",
        "Nie używaj paczki innej osoby ani paczki z innej instancji Edito.": "Do not use someone else's package or a package from another Edito instance.",
        "Nie wszystkie wybrane elementy zostały przeniesione. Nie posiadasz wymaganych uprawnień lub, w przypadku przenoszenia katalogów, katalog docelowy jest podkatalogiem katalogu źródłowego. Katalogi i pliki których nie udało się przenieść pozostały nadal w zakładce Wybrane.": "Not all selected items were moved. You do not have the required privileges or, in the case of moving directories, the target directory is a subdirectory of the source directory. Directories and files that could not be moved remain in the Selected tab.",
        "Nie wybrano ikony": "No icon selected",
        "Nie wybrano jeszcze plików": "No files selected yet",
        "Nie wybrano obrazu do edycji": "No image selected for editing",
        "Nie wybrano plików": "No files selected",
        "Nie wybrano pliku": "No file selected",
        "Nie wybrano żadnego użytkownika.": "No user selected.",
        "Nie wykonano": "Not completed",
        "nie wymuszaj zmiany hasła": "do not enforce password change",
        "Nie zdefiniowano jeszcze ról użytkowników.": "User roles have not been defined yet.",
        "Nie znaleziono pasujących elementów.": "No matching items found.",
        "Nie znaleziono strony": "Page not found",
        "Nie znaleziono właściwego widgetu": "Suitable widget not found",
        "Nie znaleziono wyników dla „%0”": "No results found for “%0”",
        "Nie znaleziono wyników.": "No results found.",
        "Nieaktywna": "Inactive",
        "Nieaktywne": "Inactive",
        "Nieaktywni": "Inactive",
        "Nieaktywny": "Inactive",
        "Nieaktywny dashboard pozostaje zapisany, ale nie jest dostępny do użycia.": "Inactive dashboard remains saved but is unavailable for use.",
        "Niebieski": "Blue",
        "niedozwolone rozszerzenie pliku (%0)": "disallowed file extension (%0)",
        "niedozwolony typ pliku (%0)": "disallowed file type (%0)",
        "Niemiecki": "German",
        "Niepotwierdzeni": "Unconfirmed",
        "Niepowodzenie": "Failure",
        "Nieprawidłowy adres email": "Invalid email address",
        "Nieprawidłowy adres URL": "Invalid URL",
        "Nieprawidłowy format. Użyj np. 13px, 18px, 90%": "Invalid format. Use e.g. 13px, 18px, 90%",
        "Nieprawidłowy format. Użyj np. 16px, 24px, 90%": "Invalid format. Use e.g. 16px, 24px, 90%",
        "Nieprzeczytane": "Unread",
        "Nieprzydatna": "Not useful",
        "Nieprzydatna odpowiedź": "Not useful response",
        "nieprzydatne": "not useful",
        "Nietrafiona odpowiedź": "Incorrect answer",
        "Nieudane logowania": "Failed logins",
        "Nieustawione": "Not set",
        "Niezapisane zmiany": "Unsaved changes",
        "Nieznane": "Unknown",
        "Nieznany stan": "Unknown status",
        "Nieznany typ pliku": "Unknown file type",
        "Nieznany użytkownik": "Unknown user",
        "Nikomu nie przydzielono uprawnień.": "No one has been assigned privileges.",
        "Nowa rozmowa": "New conversation",
        "Nowa wartość": "New value",
        "Nowe hasło": "New password",
        "Nowe hasło użytkownika. Pozostaw puste, aby go nie zmieniać.": "New user password. Leave blank to keep it unchanged.",
        "Nowe pliki zostały zapisane.": "New files have been saved.",
        "Nowy folder": "New folder",
        "Nowy folder w bieżącym katalogu": "New folder in current directory",
        "Nowy katalog powstanie w:": "New directory will be created in:",
        "Np. 820": "E.g. 820",
        "np. Edito": "e.g. Edito",
        "np. iPhone": "e.g. iPhone",
        "np. Sprzedaż — podsumowanie": "e.g. Sales — summary",
        "np. Zestawienie wyników za Q1": "e.g. Q1 results summary",
        "Numer sesji": "Session number",
        "Numer telefonu": "Phone number",
        "Numeracja prawnicza": "Legal numbering",
        "O godzinach": "At",
        "OAuth2 dla Exchange Online": "OAuth2 for Exchange Online",
        "Obecny kolor": "Current color",
        "Obiekt %0 został %1": "Object %0 has been %1",
        "Obiekt JSON": "JSON object",
        "Obraz": "Image",
        "Obraz bez alt": "Image without alt text",
        "Obraz główny": "Main image",
        "Obraz startowy": "Featured image",
        "Obraz został pomyślnie opisany": "Image was successfully described",
        "Obraz został przetworzony ale mogły wystąpić problemy z zapisem": "Image was processed, but there may have been issues saving it",
        "Obraz został zapisany jako nowy plik.": "Image was saved as a new file.",
        "Obrazy": "Images",
        "Obrazy oraz pliki PDF, DOCX, XLSX, TXT, MD i CSV, maksymalnie 4.": "Images and PDF, DOCX, XLSX, TXT, MD, and CSV files, up to 4.",
        "Obrazy zostały przeniesione.": "Images were moved.",
        "Obrót obrazu": "Rotate image",
        "Ocena": "Rating",
        "Oceny asystenta AI": "AI assistant ratings",
        "Ochrona formularzy przed automatycznymi zgłoszeniami i nadużyciami.": "Protect forms from automated submissions and abuse.",
        "Ochrona przed atakami na hasła oraz czas trwania sesji.": "Protection against password attacks and session duration.",
        "Oczekująca wiadomość": "Pending message",
        "Oczekujące": "Pending",
        "Oczekujące zaproszenia": "Pending invitations",
        "Oczekuje": "Pending",
        "Od": "From",
        "Od początku roku": "Year to date",
        "Odbicie pionowe": "Flip vertically",
        "Odbicie poziome": "Flip horizontally",
        "Odbij X": "Flip X",
        "Odbij Y": "Flip Y",
        "Odblokuj": "Unlock",
        "Odblokuj proporcje": "Unlock proportions",
        "Odblokuj proporcje wariantu": "Unlock variant proportions",
        "Odczytaj strukturę Edito i opisz dostępny workflow redaktora bez wykonywania zmian.": "Read the Edito structure and describe the editor's available workflow without making changes.",
        "Odnośniki": "Links",
        "Odpowiedzi na pytania o pierwsze połączenie.": "Answers to questions about the first connection.",
        "Odpowiedzi szybkie": "Quick responses",
        "Odpowiedzi zaawansowane": "Advanced responses",
        "Odrzuć": "Reject",
        "Odrzuca połączenie przy nieprawidłowym certyfikacie.": "Rejects the connection if the certificate is invalid.",
        "Odrzucone": "Rejected",
        "Odstęp w pionie": "Vertical spacing",
        "Odstęp w poziomie": "Horizontal spacing",
        "Odśwież": "Refresh",
        "Odśwież stronę lub sprawdź ustawienia źródła danych w widgetcie.": "Refresh the page or check the data source settings in the widget.",
        "Odwróć": "Flip",
        "Odznacz": "Uncheck",
        "Odzyskaj połączenie przez rotację tokenu.": "Recover the connection by rotating the token.",
        "Oficjalne instrukcje i dokumentacja.": "Official instructions and documentation.",
        "Ogólne": "General",
        "Ok": "Ok",
        "Okręgi": "Circles",
        "Okres": "Period",
        "Określ dostęp do funkcji systemu dla użytkowników przypisanych do tej roli.": "Set access to system features for users assigned to this role.",
        "Określ dostępność i sposób wyświetlania dashboardu.": "Set dashboard availability and display options.",
        "Określ minimalny poziom ważności zdarzeń rejestrowanych w aplikacji.": "Set the minimum severity level of events logged in the application.",
        "Określa, czy dashboard jest publiczny, czy dostępny wyłącznie według przypisanych uprawnień.": "Specifies whether the dashboard is public or available only according to assigned privileges.",
        "Określa, czy weryfikacja dwuetapowa jest wymagana dla wszystkich użytkowników.": "Specifies whether two-factor verification is required for all users.",
        "Określa, jak obraz ma być pozycjonowany względem tekstu.": "Specifies how the image should be positioned relative to text.",
        "Okruszki nawigacyjne": "Breadcrumbs",
        "Olej na płótnie": "Oil on canvas",
        "Opcje linku": "Link options",
        "Opcjonalna miniatura wyświetlana przed rozpoczęciem odtwarzania wideo.": "Optional thumbnail displayed before video playback starts.",
        "Opcjonalne": "Optional",
        "Opcjonalne. Ustaw osobne width i height, jeśli ten wariant ma inną proporcję niż obraz główny.": "Optional. Set separate width and height if this variant has a different aspect ratio than main image.",
        "Opcjonalne. Ustawia atrybuty width i height na głównym obrazie renderowanym w HTML.": "Optional. Sets the width and height attributes on main image rendered in HTML.",
        "Opcjonalny podpis pod obrazem…": "Optional caption below image…",
        "OpenTelemetry": "OpenTelemetry",
        "Operacja nieodwracalna": "Irreversible operation",
        "Opis": "Description",
        "Opis obrazka": "Image description",
        "Opis obrazu": "Image description",
        "Opisy i SEO": "Descriptions and SEO",
        "Opisz obraz, który chcesz stworzyć": "Describe the image you want to create",
        "Opisz obraz, np. zespół w nowoczesnym biurze, ciepłe światło, szerokie ujęcie": "Describe the image, e.g. a team in a modern office, warm light, wide shot",
        "Opróżnić kategorię?": "Empty category?",
        "Opróżnić kosz?": "Empty bin?",
        "Opróżnij kategorię": "Empty category",
        "Opróżnij kosz": "Empty bin",
        "Optymalizuj rozdzielczość obrazów": "Optimize image resolution",
        "Opublikowany": "Published",
        "Opublikuj ankietę na witrynie i poczekaj na odpowiedzi albo zmień liczbę ankiet w ustawieniach widgetu.": "Publish the survey on the site and wait for responses, or change the number of surveys in widget settings.",
        "Opublikuj treść na witrynie, sprawdź ustawienia witryny w widgetcie lub wybierz inny okres bądź filtr.": "Publish content on the site, check site settings in the widget, or select a different period or filter.",
        "Opuść bez zapisywania": "Leave without saving",
        "Organizacja": "Organization",
        "Oryginalny": "Original",
        "Oryginalny format": "Original format",
        "Osadź": "Embed",
        "Osiągnięto limit plików": "File limit reached",
        "Osiągnięto limit wybranych plików.": "Selected file limit reached.",
        "Ostatni miesiąc": "Last month",
        "Ostatni rok": "Last year",
        "Ostatnia aktywność": "Last activity",
        "Ostatnia strona": "Last page",
        "Ostatnie": "Recent",
        "Ostatnie 24h": "Last 24h",
        "Ostatnie 30 dni": "Last 30 days",
        "Ostatnie 7 dni": "Last 7 days",
        "Ostatnie 90 dni": "Last 90 days",
        "Ostatnie logowanie": "Last login",
        "Ostatnio używane": "Recently used",
        "Ostrzeżenia": "Warnings",
        "Ostrzeżenie": "Warning",
        "Otwórz": "Open",
        "Otwórz aplikację Claude i przejdź do karty „Code”.": "Open Claude app and go to the “Code” tab.",
        "Otwórz aplikację uwierzytelniającą i zeskanuj kod. Nie możesz zeskanować? Wpisz klucz ręcznie:": "Open authenticator app and scan the code. Can't scan it? Enter the key manually:",
        "Otwórz Codex i dodaj lokalny projekt z folderu na komputerze.": "Open Codex and add a local project from a folder on your computer.",
        "Otwórz edycję układu dashboardu, a następnie ustawienia tego widgetu.": "Open dashboard layout editing, then settings for this widget.",
        "Otwórz link": "Open link",
        "Otwórz projekt w wybranym programie": "Open project in selected program",
        "Otwórz rozmowę": "Open conversation",
        "Otwórz tokeny dostępu": "Open access tokens",
        "Otwórz tokeny dostępu i znajdź token po nadanej wcześniej nazwie.": "Open access tokens and find the token by the name you assigned earlier.",
        "Otwórz ustawienia widgetu (menu ⋮) i sprawdź źródło danych oraz wybrany okres.": "Open widget settings (⋮ menu) and check data source and selected period.",
        "Otwórz w nowej karcie": "Open in new tab",
        "Oznacz jako nieprzeczytane": "Mark as unread",
        "Oznacz jako przeczytane": "Mark as read",
        "Oznacz powiadomienia": "Mark notifications",
        "Oznacz wszystkie jako przeczytane": "Mark all as read",
        "Paczka odpowiada wybranemu programowi i jest rozpakowana w prywatnym miejscu.": "Package matches selected program and is unpacked in a private location.",
        "Paczka prowadzi do niewłaściwej instancji Edito": "Package points to the wrong Edito instance",
        "Padding": "Padding",
        "Padding komórek": "Cell padding",
        "Paginacja": "Pagination",
        "Paleta": "Palette",
        "Panel": "Panel",
        "Panel administracyjny wymaga szerokości co najmniej 360 pikseli. Poszerz okno przeglądarki lub użyj urządzenia z szerszym ekranem.": "Admin panel requires a width of at least 360 pixels. Widen browser window or use a device with a wider screen.",
        "Panel jest chwilowo niedostępny.\nWykonujemy zaplanowaną aktualizację systemu.": "Panel is temporarily unavailable.\nWe are performing a scheduled system update.",
        "Patch": "Patch",
        "październik": "October",
        "Pełna autonomia": "Full autonomy",
        "Pełna ścieżka": "Full path",
        "Pełne uprawnienia": "Full privileges",
        "Pełny administrator": "Full administrator",
        "Pełny dostęp do systemu": "Full system access",
        "Pełny ekran": "Full screen",
        "Pierwsza strona": "First page",
        "Pierwsze polecenie tylko odczytuje dane.": "First command only reads data.",
        "Pierwsze uruchomienie. Utwórz konto głównego administratora. Będzie miało pełne uprawnienia do panelu.": "First launch. Create a main administrator account. It will have full privileges for panel.",
        "Pisz zwykłym językiem. Możesz zacząć od takich poleceń:": "Write in plain language. You can start with commands like these:",
        "Pixar": "Pixar",
        "Pixel art": "Pixel art",
        "Plan gotowy": "Plan ready",
        "Plan wygasł": "Plan expired",
        "Plan zawiera operacje destrukcyjne i będzie wymagał dodatkowego potwierdzenia.": "Plan contains destructive operations and will require additional confirmation.",
        "Planowana": "Planned",
        "Planowane": "Planned",
        "Planowane zmiany": "Planned changes",
        "plik": "file",
        "Plik": "File",
        "Plik {0}": "File {0}",
        "Plik audio": "Audio file",
        "Plik binarny": "Binary file",
        "Plik CSS": "CSS file",
        "Plik CSV": "CSV file",
        "Plik DOC": "DOC file",
        "Plik DOCX": "DOCX file",
        "Plik GIF": "GIF file",
        "Plik graficzny": "Image file",
        "Plik HTML": "HTML file",
        "Plik JPEG": "JPEG file",
        "Plik JPG": "JPG file",
        "Plik MP4": "MP4 file",
        "Plik nie jest jeszcze używany.": "File is not in use yet.",
        "Plik PNG": "PNG file",
        "Plik przekracza dozwolony rozmiar %0 MB.": "File exceeds allowed size of %0 MB.",
        "Plik skompresowany": "Compressed file",
        "Plik WEBP": "WEBP file",
        "Plik wideo": "Video file",
        "Plik z logami": "Log file",
        "Plik z repozytorium": "File from repository",
        "Plik ZIP": "ZIP file",
        "Pliki": "Files",
        "Pliki w kolejce": "Files in queue",
        "Pliki współdzielone": "Shared files",
        "Pliki zostały przeniesione.": "Files have been moved.",
        "Pliki zostały wysłane": "Files have been sent",
        "plików": "files",
        "PNG, JPG, PDF": "PNG, JPG, PDF",
        "Po": "After",
        "po %0 nieudanych próbach logowania": "after %0 failed login attempts",
        "Po tym czasie bezczynności użytkownik zostanie wylogowany z panelu.": "After this period of inactivity, user will be logged out of panel.",
        "Po tym czasie panel poprosi o ustawienie nowego hasła.": "After this period, panel will ask you to set a new password.",
        "Po utracie komputera lub przypadkowym udostępnieniu paczki usuń token w panelu i utwórz nowy.": "If computer is lost or package is shared accidentally, delete token in panel and create a new one.",
        "Po włączeniu uprawnienia indywidualne i z ról nie są brane pod uwagę - użytkownik ma dostęp do wszystkiego.": "When enabled, individual and role-based privileges are ignored - user has access to everything.",
        "Po zakończeniu współpracy usuń token z listy tokenów dostępu.": "When collaboration ends, delete token from access token list.",
        "Po zapisaniu nowa konfiguracja zacznie obowiązywać dopiero po ponownym uruchomieniu procesu aplikacji. Zaplanuj restart w bezpiecznym momencie, ponieważ aktywne żądania i zadania w tle mogą zostać na krótko przerwane.": "After saving, new configuration will take effect only after application process is restarted. Schedule restart for a safe time, as active requests and background tasks may be briefly interrupted.",
        "Pobieranie rozmów…": "Fetching conversations…",
        "Pobierz": "Download",
        "Pobierz kolor z ekranu": "Pick a color from screen",
        "Pobierz paczkę od razu. Po zamknięciu widoku pełny token nie będzie ponownie dostępny. Paczka zawiera prywatny token - nie wysyłaj jej innym osobom ani nie wklejaj tokenu do rozmowy.": "Download package now. Once you close this view, full token will no longer be available. Package contains a private token - do not send it to anyone or paste token into a conversation.",
        "Pobierz plik": "Download file",
        "Pobierz rozmowy ponownie": "Download conversations again",
        "Pobierz właściwą paczkę": "Download correct package",
        "Pobrano paczkę dla niewłaściwego programu": "Package for wrong program downloaded",
        "Pobrano rozmowy": "Conversations downloaded",
        "Poczekaj na zakończenie operacji na pliku.": "Wait for file operation to finish.",
        "Poczekaj, aż asystent skończy bieżące zadanie.": "Wait for assistant to finish current task.",
        "Poczta wychodząca": "Outgoing mail",
        "Podaj 6-cyfrowy kod z aplikacji uwierzytelniającej.": "Enter 6-digit code from authenticator app.",
        "Podaj 6-znakowy kod weryfikacyjny wysłany na Twój adres email.": "Enter 6-character verification code sent to your email address.",
        "Podaj adres e-mail przypisany do konta – wyślemy jednorazowy kod do zmiany hasła.": "Enter email address associated with account – we will send a one-time code to change password.",
        "Podaj sześciocyfrowy kod weryfikacyjny wysłany na Twój adres e-mail.": "Enter six-digit verification code sent to your email address.",
        "Podana wartość nie jest prawidłowym adresem email": "Provided value is not a valid email address",
        "Podanie adresu API jest wymagane.": "API URL is required.",
        "Podanie klucza API jest wymagane.": "API key is required.",
        "Podanie modelu jest wymagane.": "Model is required.",
        "Podanie nazwy jest wymagane.": "Providing a name is required.",
        "Podczas próby logowania wystąpił problem z zapisem recaptcha. Spróbuj ponownie": "There was a problem saving recaptcha during login attempt. Try again",
        "Podczas przesyłania plików wystąpił nieznany błąd": "Unknown error occurred during file upload",
        "Podgląd": "Preview",
        "Podgląd multimediów": "Media preview",
        "Podgląd na żywo": "Live preview",
        "Podgląd obrazu": "Image preview",
        "Podgląd obrazu startowego": "Startup image preview",
        "Podgląd pliku": "File preview",
        "Podgląd tego typu pliku nie jest dostępny.": "Preview for this file type is not available.",
        "Podgląd uwzględnia presety, szerokość, wyrównanie i padding.": "Preview includes presets, width, alignment, and padding.",
        "Podkreślenie": "Underline",
        "Podmień # na docelowy adres, kotwicę istniejącej sekcji albo usuń link.": "Replace # with destination address, an anchor to an existing section, or remove link.",
        "Podmień link na publiczny adres strony, pliku albo modułu.": "Replace link with a public address for a page, file, or module.",
        "Podmień placeholder na realny adres.": "Replace placeholder with a real address.",
        "Podniesiono widget %0. Użyj klawiszy strzałek, aby zmienić jego pozycję.": "Widget %0 moved up. Use arrow keys to change its position.",
        "Podpis obrazu (figcaption)": "Image caption (figcaption)",
        "Podpis tabeli (caption)": "Table caption (caption)",
        "Podstawowe dane używane do logowania i kontaktu.": "Basic details used for login and contact.",
        "Podsumowanie": "Summary",
        "Pogrubienie": "Bold",
        "Pojawi się wkrótce na docelowym ekranie.": "Will appear on destination screen soon.",
        "Pojedyncze rozwinięcie": "Single expansion",
        "Pokaż bloki": "Show blocks",
        "Pokaż cały obraz": "Show full image",
        "Pokaż hasło": "Show password",
        "Pokaż historię": "Show history",
        "Pokaż klucz prywatny": "Show private key",
        "Pokaż mniej": "Show less",
        "Pokaż pliki": "Show files",
        "Pokaż pozostałą zmianę": "Show remaining change",
        "Pokaż pozostałe {count} zmian": "Show remaining {count} changes",
        "Pokaż pozostałe {count} zmiany": "Show remaining {count} changes",
        "Pokaż rozmowy": "Show conversations",
        "Pokaż szczegóły": "Show details",
        "Pokaż tylko moje dokumenty": "Show only my documents",
        "Pokaż w bibliotece": "Show in library",
        "Pokaż w treści": "Show in content",
        "Pokaż więcej": "Show more",
        "Pokaż wszystkie": "Show all",
        "Pokaż znaki niedrukowalne": "Show non-printing characters",
        "Pokazano {0} z {1} wyników.": "Showing {0} of {1} results.",
        "Pola dodatkowe": "Additional fields",
        "Połącz Edito z zewnętrznym asystentem AI przez MCP. W sekcji tokenów utwórz token dostępu i pobierz gotowy projekt dla Codexa lub Claude Code.": "Connect Edito to external AI assistant via MCP. In token section, create an access token and download a ready-made project for Codex or Claude Code.",
        "Połączenia z API dostawców modeli.": "Connections to model provider APIs.",
        "Połączenie działa, gdy asystent odczyta dostępne obszary redakcyjne bez błędu, nie poprosi o repozytorium ani kod projektu i nie wykona żadnej zmiany.": "Connection works when assistant reads available editorial areas without errors, does not ask for a repository or project code, and does not make any changes.",
        "Połączenie wcześniej działało, a teraz nie działa": "Connection was working before, but now it isn't",
        "Połączenie z asystentem zostało przerwane.": "Connection to assistant was interrupted.",
        "Połączenie z MCP": "Connection to MCP",
        "Połączenie z MCP - dokumentacja Edito": "Connection to MCP - Edito documentation",
        "Pole \"Email\" jest wymagane.": "Field \"Email\" is required.",
        "Pole \"Nazwa użytkownika\" jest wymagane.": "Field \"Username\" is required.",
        "Pole \"Nazwa\" jest wymagane.": "Field \"Name\" is required.",
        "Pole \"Szerokość\" jest wymagane.": "Field \"Width\" is required.",
        "Pole \"Tytuł\" jest wymagane.": "\"Title\" field is required.",
        "Pole jest wymagane": "Field is required",
        "Pole nie może zawierać spacji": "Field cannot contain spaces",
        "Pole skopiowane": "Field copied",
        "Pole wymagane": "Required field",
        "Polecenie skopiowane do schowka.": "Command copied to clipboard.",
        "Polecenie testowe": "Test command",
        "Polityka prywatności": "Privacy policy",
        "Polski": "Polish",
        "Pomiń": "Skip",
        "Pominięto": "Skipped",
        "Pominięty poziom nagłówka": "Skipped heading level",
        "Pomniejsz": "Zoom out",
        "Pomoc": "Help",
        "Pomóż mi przesłać zdjęcie i dodać je do przygotowywanej aktualności.": "Help me upload a photo and add it to the news article in progress.",
        "Pomóż mi przygotować nową aktualność, ale jeszcze jej nie publikuj.": "Help me prepare a new news article, but don't publish it yet.",
        "Pon-pt": "Mon-Fri",
        "Ponów": "Retry",
        "Ponów wyszukiwanie": "Retry search",
        "Popraw błędy formularza przed zapisaniem.": "Fix form errors before saving.",
        "Popraw hierarchię nagłówków bez przeskakiwania poziomów.": "Fix heading hierarchy without skipping levels.",
        "Poprzedni miesiąc": "Previous month",
        "Poprzedni okres": "Previous period",
        "Poprzedni plik": "Previous file",
        "Poprzedni rok": "Previous year",
        "Poprzednia strona": "Previous page",
        "Poprzednie trafienie": "Previous match",
        "Porównaj": "Compare",
        "Porównaj z aktualną wersją": "Compare with current version",
        "Porównaj: poprzedni okres": "Compare: previous period",
        "Porównanie wersji": "Version comparison",
        "Port": "Port",
        "Postęp całkowity": "Overall progress",
        "Postęp workflow": "Workflow progress",
        "Postęp wysyłania": "Upload progress",
        "Postęp wysyłania plików": "File upload progress",
        "Potwierdź": "Confirm",
        "Potwierdź i zatwierdź plan": "Confirm and approve plan",
        "Potwierdź usunięcie": "Confirm deletion",
        "Potwierdź usunięcie filtra": "Confirm filter deletion",
        "Potwierdź zmiany destrukcyjne": "Confirm destructive changes",
        "Potwierdzasz tylko usuwanie danych": "You are confirming data deletion only",
        "Potwierdzasz usuwanie i wszystkie większe zmiany": "You are confirming deletion and all major changes",
        "Potwierdzenia": "Confirmations",
        "Potwierdzenie": "Confirmation",
        "Potwierdzenie kopiowania": "Copy confirmation",
        "Potwierdzenie usunięcia": "Delete confirmation",
        "Potwierdzenie zmiany statusu": "Status change confirmation",
        "powiadomienia": "notifications",
        "Powiadomienia": "Notifications",
        "Powiadomienie": "Notification",
        "Powiększ": "Zoom in",
        "Powiększenie obrazu": "Image zoom",
        "Powrót": "Back",
        "Powrót do harmonogramu zadań": "Back to task schedule",
        "Powtórz hasło": "Repeat password",
        "Powtórzone": "Repeated",
        "Poziom dostępu": "Access level",
        "Pozostałe": "Others",
        "Pozostało %0 znaków.": "Remaining %0 characters.",
        "Pozwala przekazać własne nagłówki autoryzacyjne eksportera.": "Allows you to pass custom exporter authorization headers.",
        "Pozycja stopu %0": "Stop position %0",
        "Pozycja X znaku wodnego": "Watermark X position",
        "Pozycja Y znaku wodnego": "Watermark Y position",
        "Pozycja znaku wodnego": "Watermark position",
        "pozycji": "positions",
        "pracuje…": "working…",
        "Prawo": "Right",
        "Prawy dolny": "Bottom right",
        "Prawy górny": "Top right",
        "Prawy panel": "Right panel",
        "Preset": "Preset",
        "Próbkowanie": "Sampling",
        "Profil": "Profile",
        "Profil użytkownika": "User profile",
        "Profil został zaktualizowany.": "Profile has been updated.",
        "Proporcja": "Ratio",
        "Proporcje": "Proportions",
        "Proporcje kadru": "Aspect ratio",
        "Proszę zapisać postęp pracy i kliknąć przycisk „Aktualizuj”. Możesz również zaakceptować aktualizację poprzez odświeżenie okna przeglądarki. Brak aktualizacji może spowodować błędy.": "Please save your work progress and click the “Update” button. You can also accept the update by refreshing the browser window. Not updating may cause errors.",
        "Prywatny": "Private",
        "Prywatny klucz służący do weryfikacji odpowiedzi po stronie serwera.": "Private key used to verify response on server side.",
        "Przechowywany zaszyfrowany, widoczny tylko przy edycji.": "Stored encrypted and visible only when editing.",
        "Przeciągnij pliki albo kliknij, aby wybrać": "Drag files or click to select",
        "Przeciągnij pliki, nie foldery.": "Drag files, not folders.",
        "Przeciągnij tutaj pliki lub wybierz je z dysku": "Drag files here or select them from your device",
        "Przeciągnij, aby zmienić kolejność": "Drag to reorder",
        "Przeczytane": "Read",
        "Przed": "Before",
        "przed chwilą": "just now",
        "Przed zapisem asystent powinien przedstawić plan i poprosić o zatwierdzenie konkretnej zmiany. Przeczytaj plan przed wyrażeniem zgody.": "Before saving, assistant should present a plan and ask for approval of a specific change. Read plan before agreeing.",
        "Przeglądarka nie udostępniła obrazu ze schowka.": "Browser did not provide an image from clipboard.",
        "Przeglądarka z której korzystasz nie wspiera powiadomień PUSH": "The browser you are using does not support PUSH notifications",
        "Przejdź do konfiguracji, aby włączyć narzędzia": "Go to settings to enable tools",
        "Przejdź do pliku": "Go to file",
        "Przejrzyj zmiany przed zatwierdzeniem i upewnij się, że usuwane elementy są właściwe.": "Review changes before approval and make sure items being deleted are correct.",
        "Przekreślenie": "Strikethrough",
        "przekroczony dozwolony rozmiar pliku (%0 MB)": "exceeded allowed file size (%0 MB)",
        "Przenieś": "Move",
        "Przenieś {name}": "Move {name}",
        "Przenieś element": "Move item",
        "Przenieś element %0": "Move item %0",
        "Przenieś plik {name}": "Move file {name}",
        "Przenieś plik %0": "Move file %0",
        "Przenieś rozpakowany folder w prywatne miejsce, np. Dokumenty/Edito AI. Nie zmieniaj plików wewnątrz - zawierają gotową konfigurację, instrukcje dla asystenta i token dostępu.": "Move extracted folder to a private location, e.g. Documents/Edito AI. Do not change files inside - they contain ready-made configuration, assistant instructions, and access token.",
        "Przenieś sekcję niżej": "Move section down",
        "Przenieś sekcję wyżej": "Move section up",
        "Przenieś widget %0": "Move widget %0",
        "Przenieś wiersz": "Move row",
        "Przenieś wybrane elementy": "Move selected items",
        "Przeniesienie": "Move",
        "przeniesione": "moved",
        "Przeniesione": "Moved",
        "Przeniesiono widget %0 do kolumny %1, wiersza %2.": "Moved widget %0 to column %1, row %2.",
        "przeniesiony do kosza": "moved to bin",
        "przeniósł do kosza": "moved to bin",
        "Przepisz kod wygenerowany przez aplikację, aby potwierdzić konfigurację.": "Re-enter code generated by application to confirm configuration.",
        "Przeskok poziomu nagłówka psuje hierarchię dokumentu. Czytniki ekranu używają tej struktury do szybkiej nawigacji po treści.": "Skipping a heading level breaks document hierarchy. Screen readers use this structure to navigate content quickly.",
        "Prześlij": "Upload",
        "Przestawiaj widżety i dostosowuj ich ustawienia, aby uporządkować dashboard. Przycisk „Zapisz aranżację” zapisuje wyłącznie układ i ustawienia widżetów - filtry oraz pozostałe akcje są wyłączone w podglądzie.": "Rearrange widgets and adjust their settings to organize dashboard. “Save layout” button saves only widget layout and settings - filters and other actions are disabled in preview.",
        "Przestrzeń nazw": "Namespace",
        "Przesunięcie kadru": "Crop offset",
        "Przesuwa całą tabelę jako blok bez zmiany wyrównania tekstu w komórkach.": "Moves entire table as a block without changing text alignment in cells.",
        "Przesuwanie widoku": "Panning",
        "Przesyłanie plików": "File upload",
        "Przetestuj poprawność zapisanych kluczy": "Test saved keys validity",
        "Przetestuj ustawienia poczty": "Test mail settings",
        "Przetwarzane": "Processing",
        "Przetwarzanie…": "Processing…",
        "Przezroczystość": "Transparency",
        "Przezroczystość znaku wodnego": "Watermark transparency",
        "Przy niskim ruchu to normalne — sprawdź, czy rejestracja jest włączona na witrynie i czy wybrany okres ma sens.": "With low traffic, this is normal — check whether tracking is enabled on site and whether selected period makes sense.",
        "Przydatna": "Useful",
        "Przydatna odpowiedź": "Useful response",
        "przydatne": "useful",
        "Przygotowanie obrazów": "Image preparation",
        "Przygotowanie wysłanych plików do wyboru…": "Preparing uploaded files for selection…",
        "Przygotuj dostęp do właściwego panelu Edito oraz jeden wybrany program: Codex lub aplikację Claude z kartą Code. Zainstaluj program i zaloguj się na konto z dostępem do wybranego asystenta.": "Prepare access to the correct Edito panel and one selected program: Codex or the Claude app with Code tab. Install the program and sign in to an account with access to the selected assistant.",
        "Przygotuj panel i wybrany program.": "Prepare the panel and selected program.",
        "Przykładowe polecenia do wykorzystania w rozmowie.": "Sample commands to use in conversation.",
        "Przypisanie modeli do zadań": "Model assignment to tasks",
        "Przypisanie ról": "Assign roles",
        "Przywróć": "Restore",
        "Przywróć okno lintera": "Restore linter window",
        "Przywróć wersję": "Restore version",
        "Przywróć zestaw": "Restore set",
        "Przywrócenie": "Restore",
        "przywrócił z kosza": "restored from bin",
        "przywrócony z kosza": "restored from bin",
        "Przyznaj dostęp": "Grant access",
        "Przyznaj wszystkie uprawnienia w grupie": "Grant all privileges in group",
        "Publiczna nazwa lub tytuł materiału.": "Public name or title of material.",
        "Publiczny": "Public",
        "Publiczny klucz witryny otrzymany w konsoli Google ReCaptcha.": "Public site key obtained from Google ReCaptcha console.",
        "Publikacja": "Publication",
        "Pusta lista wyłącza monitoring żądań HTTP.": "An empty list disables HTTP request monitoring.",
        "Puste akapity często powstają po przypadkowym Enterze albo wklejeniu treści. Mogą robić nierówne odstępy na stronie.": "Empty paragraphs often appear after accidentally pressing Enter or pasting content. They can create uneven spacing on page.",
        "Pusty akapit": "Empty paragraph",
        "Raportowanie błędów aplikacji i opcjonalnych danych wydajnościowych.": "Reporting application errors and optional performance data.",
        "ReCaptcha": "ReCaptcha",
        "Regeneruj odpowiedź": "Regenerate answer",
        "Rejestr zmian": "Change log",
        "Rejestruje operacje bazodanowe jako dane telemetryczne.": "Records database operations as telemetry data.",
        "Render 3D": "3D render",
        "Repozytorium plików": "File repository",
        "Reset": "Reset",
        "Reset edytora": "Reset editor",
        "Reset filtrów": "Reset filters",
        "Resetuj filtr": "Reset filter",
        "Resetuj urządzenia 2FA": "Reset 2FA devices",
        "Resetuj widok": "Reset view",
        "Roczny": "Annual",
        "rok": "year",
        "Rok": "Year",
        "Rola": "Role",
        "Rola aktywna": "Active role",
        "Rola domyślna": "Default role",
        "Rola jest domyślnie zaznaczona podczas dodawania nowego użytkownika.": "Role is selected by default when adding a new user.",
        "Rola została dodana.": "Role has been added.",
        "Rola została usunięta.": "Role has been deleted.",
        "Rola została zaktualizowana.": "Role has been updated.",
        "Rola: …": "Role: …",
        "Rola: %0": "Role: %0",
        "Role i uprawnienia": "Roles and privileges",
        "Role użytkownika": "User roles",
        "Role zostały przypisane": "Roles have been assigned",
        "Rosnąco": "Ascending",
        "Rotacja unieważnia poprzedni token. Stara paczka przestanie działać - zastąp ją nowo pobraną.": "Rotation invalidates previous token. Old package will stop working - replace it with newly downloaded one.",
        "Rozdziel komórkę": "Split cell",
        "Rozmiar": "Size",
        "Rozmiar czcionki": "Font size",
        "Rozmiar logo": "Logo size",
        "rozmiar nieznany": "unknown size",
        "Rozmiar pliku": "File size",
        "Rozmiar tekstu": "Text size",
        "Rozmiar zdjęcia został zmieniony.": "Photo size has been changed.",
        "Rozmiar znaku wodnego": "Watermark size",
        "Rozmowa": "Conversation",
        "Rozmowa została usunięta.": "Conversation has been deleted.",
        "Rozmowy": "Conversations",
        "Różowy": "Pink",
        "Rozpakowany folder jest otwarty jako projekt, a zaufanie do projektu i serwera „edito” zostało zatwierdzone.": "Unpacked folder is open as a project, and trust in project and „edito” server has been approved.",
        "Rozpakuj nową paczkę, otwórz jej folder jako projekt i ponów test z kroku 6.": "Unpack new package, open its folder as a project, and repeat test from step 6.",
        "Rozpakuj paczkę": "Unpack package",
        "Rozpoczęto przenoszenie widgetu %0.": "Widget %0 move started.",
        "Rozpoznawanie treści i wzorów wizualnych.": "Content and visual pattern recognition.",
        "Rozwiń": "Expand",
        "Rozwiń {name}": "Expand {name}",
        "Rozwiń menu": "Expand menu",
        "Rozwiń sekcję": "Expand section",
        "Rysunek tuszem": "Ink drawing",
        "Scal komórki": "Merge cells",
        "Schowek nie zawiera pliku do wklejenia.": "Clipboard does not contain a file to paste.",
        "Ścieżka folderu": "Folder path",
        "Ścieżka zapisu została zmieniona.": "Save path has been changed.",
        "Ścieżka:": "Path:",
        "sek.": "sec.",
        "Sekcja": "Section",
        "Sekcje użytkownika": "User sections",
        "Sekret aplikacji Microsoft Entra.": "Microsoft Entra application secret.",
        "Sentry": "Sentry",
        "Separatory": "Separators",
        "Serwer SMTP": "SMTP server",
        "Sesja": "Session",
        "Sesja nr %0": "Session no. %0",
        "Sesja użytkownika": "User session",
        "Sesja wygasła": "Session expired",
        "Sesja wygasła — zaloguj się ponownie.": "Session expired — sign in again.",
        "sesji": "sessions",
        "sierpień": "August",
        "Skala": "Scale",
        "Skala obrazu": "Image scale",
        "Skala szarości": "Grayscale",
        "Skonfigurowane": "Configured",
        "Skonfiguruj aplikację uwierzytelniającą, aby kontynuować.": "Configure an authenticator app to continue.",
        "Skonfiguruj dostawcę": "Configure provider",
        "Skonfiguruj MCP": "Configure MCP",
        "Skonfiguruj model": "Configure model",
        "Skopiowano": "Copied",
        "Skopiowano identyfikator rozmowy.": "Conversation identifier copied.",
        "Skopiuj polecenie": "Copy command",
        "Skrypt SQL": "SQL script",
        "Słabe": "Weak",
        "słów": "words",
        "Słowa": "Words",
        "Słowa kluczowe związane z treścią pliku.": "Keywords related to file content.",
        "Sortowanie": "Sorting",
        "Sortowanie plików": "File sorting",
        "Sortuj według": "Sort by",
        "Sposób wyboru wartości": "Value selection method",
        "Sprawdź adres panelu, aby upewnić się, że konfigurujesz właściwą instancję Edito. Następnie kliknij „Otwórz tokeny dostępu” u góry tej strony. Przejdziesz do listy swoich tokenów.": "Check panel address to make sure you are configuring correct Edito instance. Then click “Open access tokens” at top of this page. You will be taken to your token list.",
        "Sprawdź dostęp użytkownika do poszczególnych funkcji. Widok uwzględnia zapisane uprawnienia i przypisane role.": "Check user access to individual features. View includes saved privileges and assigned roles.",
        "Sprawdź konfigurację przed rozpoczęciem pracy.": "Check configuration before getting started.",
        "Sprawdź konfigurację przed zapisaniem zmian.": "Check configuration before saving changes.",
        "Sprawdź moduł, sekcję i filtry w ustawieniach widgetu. Upewnij się, że w module są opublikowane dokumenty.": "Check module, section, and filters in widget settings. Make sure documents are published in module.",
        "Sprawdź moduł, sekcję, filtry oraz uprawnienia w ustawieniach widgetu.": "Check module, section, filters, and privileges in widget settings.",
        "Sprawdź pisownię lub wpisz krótszą frazę.": "Check spelling or enter a shorter phrase.",
        "Sprawdź pliki": "Check files",
        "Sprawdź połączenie": "Check connection",
        "Sprawdź połączenie z Google Analytics w ustawieniach witryny (CMS → Witryny → integracja GA) oraz czy na stronie działa kod śledzenia. Możesz też wybrać dłuższy okres.": "Check Google Analytics connection in site settings (CMS → Sites → GA integration) and whether tracking code is working on site. You can also select a longer period.",
        "Sprawdź SEO wskazanej strony i zaproponuj poprawki. Na razie niczego nie zapisuj.": "Check SEO for specified page and suggest improvements. Do not save anything for now.",
        "Sprawdź uprawnienia do modułu użytkowników i spróbuj ponownie.": "Check privileges for user module and try again.",
        "Sprawdź uprawnienia do modułu zastępstw i spróbuj ponownie.": "Check privileges for substitution module and try again.",
        "Sprawdź ustawienia sklepu w widgetcie i spróbuj ponownie.": "Check store settings in widget and try again.",
        "Sprawdź ustawienia sklepu w widgetcie, wybrany okres oraz czy katalog zawiera dane (sprzedaż, stany magazynowe, oceny).": "Check store settings in widget, selected period, and whether catalog contains data (sales, stock levels, ratings).",
        "Sprawdź ustawienia widgetu i dostęp do modułu ankiet.": "Check widget settings and access to surveys module.",
        "Sprawdź ustawienia witryny w widgetcie i uprawnienia do modułu treści.": "Check site settings in widget and privileges for content module.",
        "Sprawdź wersję aplikacji Claude i dostęp konta do Claude Code. W razie potrzeby skontaktuj się z administratorem firmowego konta lub helpdeskiem.": "Check Claude app version and account access to Claude Code. If needed, contact your company account administrator or help desk.",
        "Sprawdź wybrany folder. Otwórz wyłącznie edito-codex-project albo edito-claude-code-project, zależnie od programu.": "Check selected folder. Open only edito-codex-project or edito-claude-code-project, depending on program.",
        "Sprawdź, czy widget ma ustawiony sklep w ustawieniach i czy masz dostęp do modułu zamówień.": "Check whether a store is selected in widget settings and whether you have access to orders module.",
        "Sprawdzamy gotowość panelu…": "Checking panel readiness…",
        "Sprawdzanie poprawności kluczy": "Checking key validity",
        "Spróbuj ponownie": "Try again",
        "Spróbuj ponownie. Jeśli problem się powtarza, sprawdź połączenie z siecią lub spróbuj później.": "Try again. If problem persists, check your network connection or try again later.",
        "Średnia": "Average",
        "Średnica kadru": "Frame diameter",
        "Średnie": "Medium",
        "Środek": "Center",
        "Stały rozmiar kadru": "Fixed frame size",
        "Stan konta": "Account status",
        "Stan uprawnienia": "Permission status",
        "Standard": "Standard",
        "Starsze": "Older",
        "Start": "Start",
        "Status": "Status",
        "Status dokumentu": "Document status",
        "Steampunk": "Steampunk",
        "String": "String",
        "Strona": "Page",
        "Strona główna": "Home page",
        "Strony": "Pages",
        "Studio Ghibli": "Studio Ghibli",
        "styczeń": "January",
        "Styl": "Style",
        "Styl listy numerowanej": "Numbered list style",
        "Styl listy punktowanej": "Bulleted list style",
        "Styl ramki": "Border style",
        "Styl tekstu": "Text style",
        "Styl z Worda": "Word styles",
        "Style z Worda przenoszą ukryte klasy i właściwości, które mogą nadpisać wygląd strony poza edytorem.": "Word styles carry hidden classes and properties that may override page appearance outside editor.",
        "Symbole": "Symbols",
        "Synthwave": "Synthwave",
        "System": "System",
        "Szablon CMS": "CMS template",
        "Szablony": "Templates",
        "Szacowany czas:": "Estimated time:",
        "Szczegóły": "Details",
        "Szczegóły folderu": "Folder details",
        "Szczegóły komunikatu": "Message details",
        "Szczegóły kroków": "Step details",
        "Szczegóły pliku": "File details",
        "Szczegóły techniczne": "Technical details",
        "Szczegóły zadania": "Task details",
        "Szczegóły zasobu": "Resource details",
        "Szczegóły zdarzenia": "Event details",
        "Szerokość": "Width",
        "Szerokość kadru": "Frame width",
        "Szerokość proporcji": "Aspect ratio width",
        "Szerokość wynikowa": "Output width",
        "Sześć kroków do pierwszego połączenia.": "Six steps to your first connection.",
        "Szkic": "Draft",
        "Szkic węglem": "Charcoal sketch",
        "Sztuczna inteligencja": "Artificial intelligence",
        "Szukaj": "Search",
        "Szukaj dashboardu": "Search dashboard",
        "Szukaj filtra…": "Search filter…",
        "Szukaj języka…": "Search language…",
        "Szukaj kolumn": "Search columns",
        "Szukaj kolumn…": "Search columns…",
        "Szukaj lub wpisz polecenie": "Search or enter a command",
        "Szukaj po emoji, nazwie lub aliasie...": "Search by emoji, name, or alias...",
        "Szukaj po znaku, nazwie lub aliasie...": "Search by character, name, or alias...",
        "Szukaj roli": "Search role",
        "Szukaj roli…": "Search role…",
        "Szukaj rozmowy": "Search conversation",
        "Szukaj rozmowy…": "Search conversation…",
        "Szukaj uprawnienia lub modułu": "Search permission or module",
        "Szukaj uprawnienia lub modułu…": "Search permission or module…",
        "Szukaj w opcjach": "Search options",
        "Szukaj we wszystkich wersjach": "Search all versions",
        "Szukaj widoku lub dokumentu…": "Search view or document…",
        "Szukaj witryny": "Search site",
        "Szukaj witryny…": "Search site…",
        "Szukaj zestawu": "Search set",
        "Szukaj…": "Search…",
        "Szukam…": "Searching…",
        "Szybkie": "Quick",
        "Szybkie style tabeli": "Quick table styles",
        "Szyfruje połączenie z serwerem poczty.": "Encrypts connection to mail server.",
        "Ta opcja służy do włączenia lub wyłączenia dziedziczenia w danym polu": "This option is used to enable or disable inheritance in a given field",
        "Ta operacja jest nieodwracalna.": "This operation cannot be undone.",
        "Ta operacja jest nieodwracalna. Wszystkie elementy w tym widoku zostaną trwale usunięte i nie będzie można ich przywrócić.": "This operation cannot be undone. All items in this view will be permanently deleted and cannot be restored.",
        "Ta rozmowa została usunięta.": "This conversation has been deleted.",
        "Ta strona jest chroniona przez reCAPTCHA i Google.": "This page is protected by reCAPTCHA and Google.",
        "Tabela": "Table",
        "Tabela bez nagłówków": "Table without headers",
        "Tabela bez nagłówków jest trudniejsza do zrozumienia dla czytników ekranu i gorzej opisuje relację między kolumnami a danymi.": "Table without headers is harder for screen readers to understand and does a poorer job of describing relationship between columns and data.",
        "Tagi": "Tags",
        "Tak": "Yes",
        "Tarcza zegara": "Clock face",
        "Tekst": "Text",
        "Tekst alternatywny": "Alternative text",
        "Tekst znaku wodnego": "Watermark text",
        "Ten dashboard nie zawiera żadnych widgetów": "This dashboard does not contain any widgets",
        "Ten element nie zawiera menu kontekstowego.": "This item does not contain a context menu.",
        "Ten katalog jest pusty": "This folder is empty",
        "Ten plan usunie {count} elementów. Tej operacji nie można łatwo cofnąć.": "This plan will delete {count} items. This operation cannot be easily undone.",
        "Ten typ widgetu nie jest dostępny w tej wersji panelu lub został usunięty.": "This widget type is not available in this panel version or has been removed.",
        "Tenant ID": "Tenant ID",
        "Teraz": "Now",
        "Test odczytu zakończył się poprawnie.": "Read test completed successfully.",
        "Test poczty": "Mail test",
        "Testowy adres email": "Test email address",
        "Tło komórki": "Cell background",
        "Tło zostało usunięte i zapisane jako nowy plik": "Background has been removed and saved as a new file",
        "To pole jest wymagane": "This field is required",
        "To uprawnienie zostało jawnie przyznane.": "This permission was explicitly granted.",
        "To uprawnienie zostało jawnie zabronione.": "This permission was explicitly denied.",
        "To urządzenie": "This device",
        "To urządzenie zostanie natychmiast wylogowane.": "This device will be logged out immediately.",
        "Token i paczka nie zostały udostępnione innym osobom.": "Token and package have not been shared with anyone else.",
        "Token i paczka są Twoimi prywatnymi danymi.": "Token and package are your private data.",
        "Token mógł wygasnąć, zostać usunięty albo zrotowany. Utwórz lub zrotuj token w panelu, pobierz nową paczkę i otwórz jej folder jako projekt.": "Token may have expired, been deleted, or rotated. Create or rotate a token in panel, download a new package, and open its folder as a project.",
        "Tokeny dostępu": "Access tokens",
        "Traktuj paczkę i rozpakowany folder jak hasło - zawierają prywatny token, który działa w zakresie uprawnień Twojego konta Edito.": "Treat package and extracted folder like a password - they contain a private token that works within scope of your Edito account privileges.",
        "Transformacje": "Transformations",
        "Treść": "Content",
        "Treść publiczna nie powinna prowadzić do panelu administracyjnego ani endpointów admina. Dla użytkownika taki link najczęściej kończy się błędem lub ekranem logowania.": "Public content should not link to admin panel or admin endpoints. For a user, this kind of link most often ends in an error or login screen.",
        "True": "True",
        "Trwa bezpieczne logowanie przez Azure AD…": "Secure sign-in via Azure AD in progress…",
        "Trwa generowanie obrazów": "Generating images",
        "Trwa generowanie opisu dla wybranego obrazu": "Generating description for selected image",
        "Trwa konserwacja": "Maintenance in progress",
        "Tryb akordeonu": "Accordion mode",
        "Tryb ciemny": "Dark mode",
        "Tryb działania": "Operating mode",
        "Tryb jasny": "Light mode",
        "Tryb kadrowania": "Crop mode",
        "Turkusowy": "Turquoise",
        "Tutaj ustawiasz opis obrazka. Opcje techniczne są w zakładce Zaawansowane.": "Set image description here. Technical options are in Advanced tab.",
        "Twarda spacja": "Non-breaking space",
        "Twój asystent, połączony z Edito": "Your assistant, connected to Edito",
        "Twój wybór": "Your choice",
        "Twoje generowania pojawią się tutaj.": "Your generations will appear here.",
        "Twoje hasło wygasło. Zmień je na nowe.": "Your password has expired. Change it to a new one.",
        "Twoje konto nie ma dostępu do tego zasobu.\nPoproś administratora o nadanie uprawnienia.": "Your account does not have access to this resource.\nAsk your administrator to grant the privilege.",
        "Tworzenie i edycja wpisów": "Creating and editing entries",
        "Tworzenie obrazów…": "Creating images…",
        "Tworzenie, edycja i modyfikacja grafik.": "Creation, editing and modification of graphics.",
        "Tydzień": "Week",
        "Tylko aktywna rola wpływa na uprawnienia przypisanych użytkowników.": "Only active role affects privileges assigned to users.",
        "Tylko moje": "Only mine",
        "Typ": "Type",
        "Typ breakpointu": "Breakpoint type",
        "Typ integracji określa sposób uwierzytelniania.": "The integration type determines the authentication method.",
        "Typ konta": "Account type",
        "Typ obiektu": "Object type",
        "Typ pliku": "File type",
        "Typ właściwy": "Proper type",
        "Typ znaku wodnego": "Watermark type",
        "typu \"%0\" o ID \"%1\"": "type \"%0\" with ID \"%1\"",
        "Typy elementów w koszu": "Types of items in bin",
        "Tytuł sekcji": "Section title",
        "Udział dozwolonych uprawnień": "Share of allowed privileges",
        "Układ": "Layout",
        "Układ kolumn": "Column layout",
        "Układ listy": "List layout",
        "Układ nie został otwarty, dlatego dodawanie widgetów i zapis są zablokowane. Spróbuj pobrać dane ponownie.": "Layout was not opened, so adding widgets and saving are blocked. Try fetching data again.",
        "Układ widgetów dashboardu": "Dashboard widget layout",
        "Układy kolumn": "Column layouts",
        "Ukryj hasło": "Hide password",
        "Ukryj klucz prywatny": "Hide private key",
        "Ukryj postęp wysyłania": "Hide upload progress",
        "Ukryj rozmowy": "Hide conversations",
        "Ukryj szczegóły": "Hide details",
        "Ukryj wszystkie": "Hide all",
        "Ulubione": "Favorites",
        "Upewnij się, że widget ma ustawiony właściwy sklep (menu widgetu → Ustawienia) i sprawdź, czy w tym okresie pojawiły się zamówienia. Zmiana okresu w nagłówku może pomóc.": "Make sure widget has correct store set (widget menu → Settings) and check whether any orders were placed during this period. Changing period in header may help.",
        "Uprawnienia": "Privileges",
        "Uprawnienia indywidualne": "Individual privileges",
        "Uprawnienia ogólne": "General privileges",
        "Uprawnienia roli": "Role privileges",
        "Uprawnienia z ról łączą się z indywidualnymi.": "Privileges from roles are combined with individual ones.",
        "Upuść pliki, aby dodać je do kolejki": "Drop files to add them to queue",
        "Upuść pliki, żeby je dołączyć": "Drop files to attach them",
        "Upuść tutaj": "Drop here",
        "Upuść, aby dodać": "Drop to add",
        "Uri / ConnectionString": "Uri / ConnectionString",
        "URL": "URL",
        "Uruchamiam wykonanie planu...": "Running plan execution...",
        "Uruchom gotowy projekt bez używania terminala.": "Run ready project without using terminal.",
        "Uruchom zadanie": "Run task",
        "urządzeń": "devices",
        "Urządzenia uwierzytelniające": "Authentication devices",
        "Urządzenia uwierzytelniające zostały zresetowane.": "Authentication devices have been reset.",
        "Urządzenie nie zostało znalezione.": "Device not found.",
        "Urządzenie zostało usunięte.": "Device has been deleted.",
        "Usługa AI jest obecnie niedostępna. Spróbuj ponownie za chwilę.": "The AI service is currently unavailable. Try again in a moment.",
        "Usługa rozmów jest niedostępna. Pobierz rozmowy ponownie, aby sprawdzić połączenie.": "Conversation service is unavailable. Fetch conversations again to check connection.",
        "Usługa wyszukiwania nie odpowiedziała. Widoki i polecenia działają normalnie.": "Search service did not respond. Views and commands are working normally.",
        "Ustaw dla całej grupy": "Set for entire group",
        "Ustaw dziedziczenie wszystkich uprawnień w grupie": "Set inheritance for all privileges in group",
        "Ustaw nazwę i opis dashboardu.": "Set dashboard name and description.",
        "Ustaw nowe hasło": "Set new password",
        "Ustaw poziomy logów, które będą wysyłane do poszczególnych rejestrów.": "Set log levels to send to each registry.",
        "Ustaw poziomy logów, które będą zbierane z poszczególnych przestrzeni nazw.": "Set log levels to collect from each namespace.",
        "Ustaw prawdziwy adres albo usuń linkowanie z tego fragmentu tekstu.": "Set a valid address or remove link from this piece of text.",
        "Ustaw realny adres linku albo usuń link.": "Set a valid link address or remove link.",
        "Ustaw ścieżkę": "Set path",
        "Ustaw własne wymiary": "Set custom dimensions",
        "Ustaw wyjątki względem dostępu wynikającego z ról. Zmiany zatwierdzisz przyciskiem zapisu użytkownika.": "Set exceptions to access granted by roles. Save changes using user's save button.",
        "Ustawienia": "Settings",
        "Ustawienia kolumn": "Column settings",
        "Ustawienia roli": "Role settings",
        "Ustawienia weryfikacji dwuetapowej zostały zapisane.": "Two-step verification settings have been saved.",
        "Ustawienia widgetów zostały zapisane": "Widget settings have been saved",
        "Ustawienia widgetu": "Widget settings",
        "Ustawienia wspólne": "Shared settings",
        "Ustawienia zostały zapisane.": "Settings have been saved.",
        "Ustawienie logo witryny jako znaku wodnego": "Set site logo as watermark",
        "Ustawienie obowiązuje tylko w tej rozmowie. Nowe rozmowy startują w trybie z potwierdzaniem operacji.": "Setting applies only to this conversation. New conversations start in mode that requires operation confirmation.",
        "Usuń": "Delete",
        "USUŃ": "DELETE",
        "Usuń akapit. Jeśli odstęp jest celowy, użyj elementu layoutu albo stylu przewidzianego dla tej treści.": "Delete paragraph. If spacing is intentional, use a layout element or style intended for this content.",
        "Usuń bieżącą kolumnę": "Delete current column",
        "Usuń blok kodu": "Delete code block",
        "Usuń filtr": "Delete filter",
        "Usuń formatowanie": "Remove formatting",
        "Usuń kolumnę": "Delete column",
        "Usuń kontekst strony": "Remove page context",
        "Usuń link": "Delete link",
        "Usuń napisy": "Remove captions",
        "Usuń obraz": "Delete image",
        "Usuń obraz startowy": "Remove start image",
        "Usuń plik": "Delete file",
        "Usuń plik z listy": "Delete file from list",
        "Usuń pusty akapit, jeśli nie jest potrzebny jako świadomy odstęp.": "Delete empty paragraph if it is not needed as intentional spacing.",
        "Usuń rozmowę": "Delete conversation",
        "Usuń sekcję": "Delete section",
        "Usuń tabelę": "Delete table",
        "Usuń tło": "Remove background",
        "Usuń trwale": "Delete permanently",
        "Usuń układ kolumn": "Delete column layout",
        "Usuń urządzenie": "Delete device",
        "Usuń urządzenie, aby odwołać zapamiętane automatyczne logowanie.": "Remove device to revoke remembered automatic login.",
        "Usuń wariant breakpointu": "Delete breakpoint variant",
        "Usuń widget z dashboardu (menu ⋮ → Usuń) albo skontaktuj się z administratorem systemu.": "Remove widget from dashboard (⋮ menu → Delete) or contact system administrator.",
        "Usuń wiersz": "Delete row",
        "Usuń wklejone style Worda i zostaw formatowanie z edytora.": "Remove pasted Word styles and keep formatting from editor.",
        "Usuń wszystkie": "Delete all",
        "Usuń wybrane elementy": "Delete selected items",
        "Usuń załącznik": "Remove attachment",
        "Usuń zasób": "Remove resource",
        "Usunąć całą historię rozmów? Tej operacji nie można cofnąć.": "Delete entire conversation history? This operation cannot be undone.",
        "Usunąć tę rozmowę?": "Delete this conversation?",
        "usunął": "removed",
        "Usunął": "Removed",
        "Usunięcie": "Removal",
        "usunięte": "deleted",
        "Usunięte": "Deleted",
        "usunięto": "deleted",
        "usunięty": "deleted",
        "Usuwanie tła...": "Removing background...",
        "Utwórz katalog": "Create directory",
        "Utwórz osobisty token, pobierz gotowy projekt i otwórz go w Codexie lub Claude Code. Poniżej znajdziesz dokładną kolejność działań oraz polecenie sprawdzające połączenie.": "Create a personal token, download the ready-to-use project, and open it in Codex or Claude Code. Below, you'll find the exact steps and a command to check the connection.",
        "Utwórz token": "Create token",
        "Utworzone zasoby": "Created resources",
        "Utworzył": "Created",
        "Uwierzytelnianie tokenem Microsoft 365.": "Microsoft 365 token authentication.",
        "Uzupełnij wymagane pola przed testem.": "Complete required fields before testing.",
        "Uzupełnij wymagane ustawienia źródła danych tego widgetu.": "Complete required data source settings for this widget.",
        "Użycia": "Usage",
        "Użyte narzędzia": "Tools used",
        "Użytkownicy": "Users",
        "Użytkownicy w tej roli": "Users in this role",
        "Użytkownik": "User",
        "Użytkownik \"%0\" %1 obiekt %2": "User \"%0\" %1 object %2",
        "Użytkownik ma pełny dostęp niezależnie od indywidualnych przypisań. Lista obejmuje tylko zapisane wpisy.": "User has full access regardless of individual assignments. List includes saved entries only.",
        "Użytkownik nie będzie otrzymywał żadnych powiadomień.": "User will not receive any notifications.",
        "Użytkownik nie może się zalogować, dopóki konto nie jest aktywne.": "User cannot log in until account is active.",
        "Użytkownik usunięty": "User deleted",
        "Użytkownik zablokowany": "User blocked",
        "Użytkownik zatwierdzony": "User approved",
        "Użytkownik został dodany.": "User has been added.",
        "Użytkownik został usunięty.": "User has been deleted.",
        "Użytkownik został utworzony. Możesz zalogować się na swoje konto.": "User has been created. You can log in to your account.",
        "Użytkownik został wylogowany.": "User has been logged out.",
        "Użytkownik został zaktualizowany.": "User has been updated.",
        "Użytkownik został zanonimizowany.": "User has been anonymized.",
        "Używany do budowy linków w treści wiadomości.": "Used to build links in message content.",
        "W czym mogę pomóc?": "How can I help?",
        "W dniach miesiąca": "On days of month",
        "W dniach tygodnia": "On days of week",
        "W lewo": "Left",
        "W menu z trzema kropkami wybierz „Rotuj”. Przeczytaj komunikat i potwierdź, jeśli chcesz zastąpić dotychczasowy token.": "Select “Rotate” from three-dot menu. Read message and confirm if you want to replace current token.",
        "W miesiącach": "In months",
        "W minutach": "In minutes",
        "W nowej rozmowie wyślij poniższe polecenie:": "Send following command in a new conversation:",
        "W polu „Data wygaśnięcia” wybierz uzgodniony termin ważności.": "Select agreed expiration date in “Expiration date” field.",
        "W polu „Nazwa” wpisz nazwę programu i swoje imię, np. „Codex - Anna Kowalska”. Dzięki temu rozpoznasz token na liście.": "Enter program name and your name in “Name” field, e.g. “Codex - Anna Kowalska”. This will help you identify token in list.",
        "W prawo": "Right",
        "W recenzji": "In review",
        "W toku": "In progress",
        "W tym miejscu można wybrać tylko jeden plik.": "You can select only one file here.",
        "W widoku nowego tokenu pobierz paczkę dla swojego programu, zanim zamkniesz okno.": "Download package for your program in new token view before closing window.",
        "W wybranym okresie nie ma zamówień spełniających kryteria tego widgetu.": "No orders matching this widget's criteria were found for selected period.",
        "W wybranym okresie nie odnotowano ruchu w Google Analytics dla tej witryny.": "No Google Analytics traffic was recorded for this site during selected period.",
        "w zakresie": "within",
        "Walidacja certyfikatu SSL": "SSL certificate validation",
        "Walidacja treści": "Content validation",
        "Wariant dla": "Variant for",
        "Wariant mobilny dodawaj tylko wtedy, gdy na telefonie ma się wyświetlić inna grafika.": "Add mobile variant only if you want a different image to appear on phone.",
        "Warianty responsywne": "Responsive variants",
        "Wartość domyślna": "Default value",
        "Wartość musi być liczbą całkowitą": "Value must be an integer",
        "Wartość musi być liczbą dodatnią": "Value must be positive",
        "Wartość musi być liczbą ujemną": "Value must be negative",
        "Wartości od 0 do 1. 0 oznacza 0%, a 1 oznacza 100%.": "Values from 0 to 1. 0 means 0%, and 1 means 100%.",
        "Warunki korzystania z usług Google": "Google Terms of Service",
        "Wbudowane": "Built-in",
        "Wczoraj": "Yesterday",
        "Wczytaj więcej": "Load more",
        "Wczytanie obrazu": "Image loading",
        "wczytuje rozmowę…": "loading conversation…",
        "Wczytuję rozmowę...": "Loading conversation...",
        "Wczytywanie": "Loading",
        "Wczytywanie aktywnych sesji": "Loading active sessions",
        "Wczytywanie dziennika…": "Loading log…",
        "Wczytywanie emoji...": "Loading emoji...",
        "Wczytywanie folderów": "Loading folders",
        "Wczytywanie historii wersji…": "Loading version history…",
        "Wczytywanie konfiguracji AI…": "Loading AI configuration…",
        "Wczytywanie miejsc użycia": "Loading usage locations",
        "Wczytywanie plików": "Loading files",
        "Wczytywanie powiadomień": "Loading notifications",
        "Wczytywanie ról": "Loading roles",
        "Wczytywanie rozmów…": "Loading conversations…",
        "Wczytywanie układu dashboardu": "Loading dashboard layout",
        "Wczytywanie uprawnień": "Loading privileges",
        "Wczytywanie ustawień zabezpieczeń…": "Loading security settings…",
        "Wczytywanie zapamiętanych urządzeń": "Loading remembered devices",
        "Wczytywanie zdarzenia…": "Loading event…",
        "Wczytywanie…": "Loading…",
        "Wdrożenie": "Deployment",
        "We wszystkich folderach": "In all folders",
        "Weekend": "Weekend",
        "wejść": "entries",
        "wejścia": "entries",
        "wejście": "entry",
        "Wektoryzacja tekstu": "Text vectorization",
        "Wektoryzacja tekstu, analiza semantyczna": "Text vectorization and semantic analysis",
        "Wersja": "Version",
        "Wersja API": "API version",
        "Wersja backendu: %0": "Backend version: %0",
        "Wersja compact": "Compact version",
        "Wersja językowa": "Language version",
        "Weryfikacja dwuetapowa": "Two-factor authentication",
        "Weryfikacja dwuetapowa (2FA)": "Two-factor authentication (2FA)",
        "Weryfikacja dwuetapowa jest dostępna wyłącznie dla kont lokalnych.": "Two-factor authentication is available only for local accounts.",
        "Weryfikacja dwuetapowa jest wymagana przez system.": "Two-factor authentication is required by system.",
        "Weryfikacja dwuetapowa została wyłączona.": "Two-factor authentication has been disabled.",
        "Wiadomość": "Message",
        "Wiadomość do asystenta": "Message to assistant",
        "Wiadomość testowa została wysłana.": "Test message has been sent.",
        "Widget": "Widget",
        "Widget nie ma danych do wyświetlenia przy obecnych ustawieniach.": "Widget has no data to display with current settings.",
        "Widget w trakcie przygotowywania": "Widget is being prepared",
        "Widget wymaga konfiguracji": "Widget requires configuration",
        "Widoczna na liście dostawców i w wyborze modeli.": "Displayed in the provider list and model selection.",
        "Widoczne": "Visible",
        "Widoczność": "Visibility",
        "Widoczność filtra": "Filter visibility",
        "Widok": "View",
        "Widok plików": "File view",
        "Więcej": "More",
        "Więcej akcji": "More actions",
        "Więcej akcji widgetu %0": "More actions for widget %0",
        "Więcej informacji": "More information",
        "Wiele rozwinięć": "Multiple expansions",
        "Wiersz nagłówkowy": "Header row",
        "Wiersze": "Rows",
        "Wiersze naprzemienne": "Alternating rows",
        "Windows: w folderze „Pobrane” kliknij ZIP prawym przyciskiem i wybierz „Wyodrębnij wszystkie”.": "Windows: in “Downloads” folder, right-click ZIP and select “Extract all”.",
        "Wizja": "Vision",
        "Wklej": "Paste",
        "Wklej adres strony dokumentu Studio albo wpisz moduł/sekcja/id.": "Paste the Studio document page address or enter module/section/id.",
        "Wklej adres URL…": "Paste URL…",
        "Wklej bez formatowania": "Paste without formatting",
        "Wklej link do dokumentu Studio w formacie /modules/moduł/sekcja/id.": "Paste the link to the Studio document in the format /modules/module/section/id.",
        "Wklej treść jako czysty tekst albo usuń formatowanie i ustaw je ponownie narzędziami edytora.": "Paste content as plain text or remove formatting and reapply it using editor tools.",
        "Włącz": "Enable",
        "Włącz pełną autonomię": "Enable full autonomy",
        "Włącza śledzenie transakcji i pomiar wydajności.": "Enables transaction tracking and performance measurement.",
        "Włączona": "Enabled",
        "Włączone": "Enabled",
        "Włączyć pełną autonomię?": "Enable full autonomy?",
        "Właściwości komórki": "Cell properties",
        "Właściwości tabeli": "Table properties",
        "Własne klasy zależą od stylów projektu i nie są odwzorowane w podglądzie.": "Custom classes depend on project styles and are not reflected in preview.",
        "Własny": "Custom",
        "Własny breakpoint": "Custom breakpoint",
        "Własny przedział": "Custom range",
        "Własny rozmiar (np. 13px)": "Custom size (e.g. 13px)",
        "Wpisz 6-cyfrowy kod": "Enter 6-digit code",
        "Wpisz adresy po przecinku.": "Enter addresses separated by commas.",
        "Wpisz co najmniej %0 znaki, aby przeszukać strony i dokumenty.": "Enter at least %0 characters to search pages and documents.",
        "Wpisz czytelny tekst linku, dodaj obraz z altem albo usuń pusty link.": "Enter link text, add an image with alt text, or delete the empty link.",
        "Wpisz USUŃ, aby odblokować wykonanie:": "Type DELETE to unlock execution:",
        "Wpisz, aby wyszukać…": "Type to search…",
        "Wprowadzona wartość jest nieprawidłowa": "Entered value is invalid",
        "Wprowadzona wartość jest za długa": "Entered value is too long",
        "Wprowadzona wartość jest za krótka": "Entered value is too short",
        "Wprowadzona wartość jest za niska": "Entered value is too low",
        "Wprowadzona wartość jest za wysoka": "Entered value is too high",
        "Wprowadzona wartość nie jest poprawna": "Entered value is not correct",
        "Wróć do logowania": "Back to login",
        "Wróć do pulpitu": "Back to dashboard",
        "Wróć do rozmowy": "Back to conversation",
        "Wróć do widoku nowego lub zrotowanego tokenu i pobierz właściwy wariant: edito-codex-project.zip dla Codexa albo edito-claude-code-project.zip dla Claude Code.": "Return to the new or rotated token view and download the appropriate variant: edito-codex-project.zip for Codex or edito-claude-code-project.zip for Claude Code.",
        "Wróć do zmian": "Back to changes",
        "wrzesień": "September",
        "Wskaż rozpakowany folder:": "Select the extracted folder:",
        "Wspólne": "Shared",
        "Wstaw": "Insert",
        "Wstaw / edytuj multimedia": "Insert / edit media",
        "Wstaw akordeon": "Insert accordion",
        "Wstaw blok kodu": "Insert code block",
        "Wstaw cytat": "Insert quote",
        "Wstaw cztery kolumny 1/4": "Insert four columns 1/4",
        "Wstaw dwie kolumny 1/3 oraz 2/3": "Insert two columns 1/3 and 2/3",
        "Wstaw dwie kolumny 2/3 oraz 1/3": "Insert two columns 2/3 and 1/3",
        "Wstaw dwie równe kolumny": "Insert two equal columns",
        "Wstaw kolumnę z lewej": "Insert column on left",
        "Wstaw kolumnę z prawej": "Insert column on right",
        "Wstaw kotwicę": "Insert anchor",
        "Wstaw linię poziomą": "Insert horizontal line",
        "Wstaw link": "Insert link",
        "Wstaw multimedia": "Insert media",
        "Wstaw obraz": "Insert image",
        "Wstaw plik": "Insert file",
        "Wstaw tabelę": "Insert table",
        "Wstaw trzy kolumny 1/2, 1/4 oraz 1/4": "Insert three columns 1/2, 1/4, and 1/4",
        "Wstaw trzy kolumny 1/3": "Insert three columns 1/3",
        "Wstaw trzy kolumny 1/4, 1/2 oraz 1/4": "Insert three columns 1/4, 1/2, and 1/4",
        "Wstaw trzy kolumny 1/4, 1/4 oraz 1/2": "Insert three columns 1/4, 1/4, and 1/2",
        "Wstaw układ": "Insert layout",
        "Wstaw wiersz poniżej": "Insert row below",
        "Wstaw wiersz powyżej": "Insert row above",
        "Wstaw/edytuj obraz": "Insert/edit image",
        "Wstawianie": "Inserting",
        "Wstawki": "Snippets",
        "Wszyscy użytkownicy": "All users",
        "Wszystkie": "All",
        "Wszystkie dane osobowe użytkownika znajdujące się w systemie zostaną usunięte!\n\nCzy na pewno chcesz wykonać akcję?": "All of the user's personal data in the system will be deleted!\n\nAre you sure you want to perform this action?",
        "Wszystkie elementy": "All items",
        "Wszystkie filtry są już dodane.": "All filters have already been added.",
        "Wszystkie kroki zostały wykonane.": "All steps have been completed.",
        "Wszystkie urządzenia uwierzytelniające tego użytkownika zostaną usunięte.\n\nCzy na pewno chcesz wykonać akcję?": "All of this user's authentication devices will be deleted.\n\nAre you sure you want to perform this action?",
        "Wszystkie wiersze": "All rows",
        "Wszystko zaznaczone": "Everything selected",
        "Wybierz": "Select",
        "Wybierz „Pobierz projekt dla Claude Code”.": "Select “Download project for Claude Code”.",
        "Wybierz „Pobierz projekt dla Codexa”.": "Select “Download project for Codex”.",
        "Wybierz docelową ścieżkę zapisu.": "Select destination save path.",
        "Wybierz dokument z listy.": "Select a document from the list.",
        "Wybierz dostawcę": "Select provider",
        "Wybierz emoji": "Select emoji",
        "Wybierz godzinę": "Select time",
        "Wybierz ikonę": "Select icon",
        "Wybierz ikonę filtra": "Select filter icon",
        "Wybierz ikonę...": "Select icon...",
        "Wybierz inny rodzaj operacji albo inną grupę.": "Select a different operation type or group.",
        "Wybierz jeden lub kilka stylów. Podgląd aktualizuje się przed zapisaniem zmian.": "Select one or more styles. Preview updates before changes are saved.",
        "Wybierz katalog docelowy dla zaznaczonych plików i katalogów.": "Select a destination folder for selected files and folders.",
        "Wybierz kolor": "Select color",
        "Wybierz kolor tekstu": "Select text color",
        "Wybierz kolor tła": "Select background color",
        "Wybierz logo": "Select logo",
        "Wybierz minutę": "Select minute",
        "Wybierz model": "Select model",
        "Wybierz napisy ze storage": "Select captions from storage",
        "Wybierz obraz ze storage": "Select image from storage",
        "Wybierz odbiorcę danych telemetrycznych.": "Select telemetry data recipient.",
        "Wybierz paczkę zgodną ze swoim asystentem.": "Select the package compatible with your assistant.",
        "Wybierz plik": "Select file",
        "Wybierz plik .vtt ze storage": "Select a .vtt file from storage",
        "Wybierz plik napisów w formacie WebVTT (.vtt).": "Select a captions file in WebVTT format (.vtt).",
        "Wybierz pliki": "Select files",
        "Wybierz pliki (do {0})": "Select files (up to {0})",
        "Wybierz rolę lub osobę": "Select a role or person",
        "Wybierz rozpakowany folder projektu, a nie ZIP ani cały folder „Pobrane”. Nie trzeba kopiować konfiguracji do ustawień aplikacji, instalować Claude Code CLI ani wpisywać komend w terminalu.": "Select the extracted project folder, not the ZIP or the entire “Downloads” folder. There is no need to copy the configuration to application settings, install Claude Code CLI, or enter commands in the terminal.",
        "Wybierz ścieżkę zapisu": "Select save path",
        "Wybierz sposób potwierdzania logowania do swojego konta.": "Select how to confirm sign-in to your account.",
        "Wybierz środowisko „Local”, kliknij „Select folder” i wskaż folder:": "Select the “Local” environment, click “Select folder,” and choose the folder:",
        "Wybierz układ kolumn": "Select column layout",
        "Wybierz użytkowników dla których chcesz wykonać akcje": "Select users for whom you want to perform actions",
        "Wybierz wersję %0": "Select version %0",
        "Wybierz witrynę w ustawieniach tego widgetu.": "Select a site in this widget's settings.",
        "Wybierz z dysku": "Choose from disk",
        "Wybierz zdjęcie użytkownika": "Select user photo",
        "Wybierz ze storage": "Select from storage",
        "Wybierz znak specjalny": "Select special character",
        "Wybierz, kto ma dostęp do dashboardu.": "Select who has access to dashboard.",
        "Wybierz...": "Select...",
        "Wybierz…": "Select…",
        "Wybór języka": "Language selection",
        "Wybrana data jest poza dozwolonym zakresem.": "The selected date is outside the allowed range.",
        "Wybrane": "Selected",
        "Wybrane elementy zostały przeniesione.": "Selected items have been moved.",
        "Wybrane elementy zostały przywrócone.": "Selected items have been restored.",
        "Wybrane elementy zostały trwale usunięte.": "Selected items have been permanently deleted.",
        "Wybrane elementy zostały usunięte.": "Selected items have been deleted.",
        "Wybrane pliki": "Selected files",
        "Wybrane: %0": "Selected: %0",
        "Wybranie dostawcy jest wymagane.": "Selecting a provider is required.",
        "Wybrano %0 użytkowników.": "Selected %0 users.",
        "Wybrano jednego użytkownika.": "Selected one user.",
        "Wybrano:": "Selected:",
        "Wybrany element został usunięty.": "Selected item has been deleted.",
        "Wyczyść": "Clear",
        "Wyczyść filtry": "Clear filters",
        "Wyczyść historię": "Clear history",
        "Wyczyść kolejkę": "Clear queue",
        "Wyczyść styl": "Clear style",
        "Wyczyść styl tabeli": "Clear table style",
        "Wyczyść wartość": "Clear value",
        "Wyczyść wybór": "Clear selection",
        "Wyczyść wyszukiwanie": "Clear search",
        "Wyczyść zaznaczenie (Esc)": "Clear selection (Esc)",
        "Wygasa:": "Expires:",
        "Wygenerowane obrazy": "Generated images",
        "Wygenerowany obraz": "Generated image",
        "Wyjustuj": "Justify",
        "Wykluczenia logów konsoli": "Console log exclusions",
        "Wykonaj": "Execute",
        "Wykonane zmiany": "Changes made",
        "Wykonanie planu zostało anulowane.": "Plan execution was canceled.",
        "Wykonano": "Completed",
        "Wykonuję operację...": "Performing operation...",
        "Wykonuję plan...": "Executing plan...",
        "Wykonywanie": "Processing",
        "Wykres danych dashboardu": "Dashboard data chart",
        "Wyłącz 2FA": "Disable 2FA",
        "Wyłączona": "Disabled",
        "wyłączone (użytkownik decyduje sam)": "disabled (user decides)",
        "Wyłączone wysyłanie powiadomień": "Disabled notification sending",
        "Wyloguj się": "Log out",
        "Wyloguj zalogowanego obecnie użytkownika": "Log out currently logged-in user",
        "wymaga uwagi": "requires attention",
        "Wymaga zatwierdzenia powyżej.": "Requires approval above.",
        "Wymagaj znaków specjalnych w hasłach": "Require special characters in passwords",
        "Wymagana tylko dla Azure OpenAI.": "Required only for Azure OpenAI.",
        "wymagane - Authenticator": "required - Authenticator",
        "wymagane - dowolna metoda": "required - any method",
        "wymagane - Email": "required - Email",
        "Wymagane jest ustawienie minimalnej długości hasła": "Setting minimum password length is required",
        "Wymagania stawiane hasłom użytkowników panelu.": "Password requirements for panel users.",
        "Wymagany": "Required",
        "Wymiary": "Dimensions",
        "Wymiary HTML obrazu głównego": "Main image HTML dimensions",
        "Wymiary HTML wariantu": "Variant HTML dimensions",
        "Wymiary obrazu": "Image dimensions",
        "Wymuś zmianę hasła": "Force password change",
        "Wynik": "Result",
        "Wynika z roli": "Inherited from role",
        "Wyniki": "Results",
        "Wyniki wyszukiwania": "Search results",
        "Wypełnij miniaturę": "Fill thumbnail",
        "Wypełnij miniaturę – przytnij obraz": "Fill thumbnail – crop image",
        "Wypróbuj możliwości AI": "Try AI features",
        "Wyrażenie własne": "Custom expression",
        "Wyrównanie": "Alignment",
        "Wyrównanie multimediów": "Media alignment",
        "Wyrównanie obrazu": "Image alignment",
        "Wyrównanie pionowe": "Vertical alignment",
        "Wyrównanie tekstu": "Text alignment",
        "Wyróżnione": "Featured",
        "Wysłane": "Sent",
        "wysłano": "sent",
        "Wysłano": "Sent",
        "Wyślij": "Send",
        "Wyślij kod": "Send code",
        "Wyślij pliki": "Send files",
        "Wyślij ponownie": "Resend",
        "Wyślij ponownie (%0s)": "Resend (%0s)",
        "Wysoka": "High",
        "Wysokość": "Height",
        "Wysokość kadru": "Frame height",
        "Wysokość proporcji": "Aspect ratio height",
        "Wysokość stała dla tego typu widżetu.": "Fixed height for this widget type.",
        "Wysokość wynikowa": "Resulting height",
        "Wyśrodkuj": "Center",
        "Wystąpił błąd podczas ładowania obrazu. Spróbuj ponownie.": "Error occurred while loading image. Try again.",
        "Wystąpił błąd podczas próby exportu użytkowników.": "Error occurred during user export attempt.",
        "Wystąpił błąd podczas próby importu użytkowników.": "Error occurred during user import attempt.",
        "Wystąpił błąd połączenia. Upewnij się że masz włączony internet i spróbuj ponownie.": "Connection error. Ensure internet is enabled and try again.",
        "Wystąpił błąd serwera podczas obsługiwania wybranej operacji. Spróbuj ponownie.": "Server error occurred during selected operation. Try again.",
        "Wystąpił nieznany błąd serwera podczas obsługiwania wybranej operacji. Spróbuj ponownie.": "Unknown server error occurred during selected operation. Try again.",
        "Wystąpił problem podczas pobierania danych widgetu.": "There was a problem fetching widget data.",
        "Wystąpił problem podczas przetwarzania obrazu.": "There was a problem processing image.",
        "Wyświetlana jako autor wiadomości.": "Displayed as message author.",
        "Wyświetlany domyślnie na wszystkich ekranach, jeśli nie dodasz osobnego wariantu mobilnego.": "Displayed by default on all screens unless you add a separate mobile variant.",
        "wyświetleń": "views",
        "Wysyłaj dane o użytkowniku": "Send user data",
        "wysyłanie niedostępne": "sending unavailable",
        "Wysyłanie plików": "File upload",
        "Wysyłanie wiadomości niedostępne": "Message sending unavailable",
        "Wysyłanie…": "Sending…",
        "Wyszukaj emoji": "Search emoji",
        "Wyszukaj ikonę": "Search icon",
        "Wyszukaj ikonę...": "Search icon...",
        "Wyszukaj widget": "Search widget",
        "Wyszukaj widget...": "Search widget...",
        "Wyszukaj znak specjalny": "Search special character",
        "Wyszukaj...": "Search...",
        "Wyszukaj…": "Search…",
        "Wyszukiwanie i polecenia": "Search and commands",
        "Wytnij": "Cut",
        "Wyzeruj": "Reset",
        "Wzmacnia obrys tabeli i linie siatki, dzięki czemu układ jest bardziej wyraźny.": "Strengthens table borders and gridlines, making layout clearer.",
        "X": "X",
        "Y": "Y",
        "z": "of",
        "Z komentarzem": "With comment",
        "Z uprawnieniami": "With privileges",
        "za %0 %1": "in %0 %1",
        "za chwilę": "in a moment",
        "Zaakceptowany": "Accepted",
        "Zaawansowane": "Advanced",
        "Zabierz dostęp": "Revoke access",
        "Zablokuj": "Block",
        "Zablokuj proporcje": "Lock aspect ratio",
        "Zablokuj proporcje wariantu": "Lock variant aspect ratio",
        "Zabroń - jawnie odebrane": "Deny - explicitly revoked",
        "Zabroń wszystkich uprawnień w grupie": "Deny all privileges in group",
        "Zabronione": "Denied",
        "Zacznij nową rozmowę - pojawi się tutaj.": "Start a new conversation - it will appear here.",
        "Zacznij pisać, aby wyszukać użytkownika…": "Start typing to search for a user…",
        "Zacznij w instancji Edito, z którą chcesz pracować.": "Start in the Edito instance you want to work with.",
        "Zadaj pytanie albo poproś o akcję - asystent korzysta z modułów CMS.": "Ask a question or request an action - assistant uses CMS modules.",
        "Zadanie zostało uruchomione.": "Task has been started.",
        "Zadanie zostało włączone": "Task has been enabled",
        "Zadanie zostało wyłączone": "Task has been disabled",
        "Żądany zasób jest niedostępny albo żądanie jest nieprawidłowe.\nSprawdź adres lub wróć do panelu.": "Requested resource is unavailable or request is invalid.\nCheck address or return to panel.",
        "Żadna rozmowa nie pasuje do wyszukiwania.": "No conversation matches your search.",
        "Zaimportowano listę użytkowników.": "User list has been imported.",
        "Zakolejkowane": "Queued",
        "Zakończ": "End",
        "Zakończ sesję, aby natychmiast wylogować to urządzenie.": "End session to immediately log out this device.",
        "Zakończone": "Finished",
        "Zakończono": "Completed",
        "Zakończono z błędami": "Completed with errors",
        "Zakres": "Scope",
        "Zakres danych": "Data scope",
        "Zakres witryny i języka": "Site and language scope",
        "Zalecane": "Recommended",
        "Zalogowano jako": "Logged in as",
        "Zalogowany": "Logged in",
        "Zaloguj się": "Log in",
        "Zaloguj się do właściwego panelu i pobierz nową paczkę. Nie przenoś paczek między instancjami.": "Log in to the correct panel and download a new package. Do not transfer packages between instances.",
        "Zaloguj się na swoje konto, aby przejść do panelu.": "Log in to your account to access the panel.",
        "Zamień": "Replace",
        "Zamień na": "Replace with",
        "Zamień na…": "Replace with…",
        "Zamknij": "Close",
        "Zamknij asystenta": "Close assistant",
        "Zamknij komunikat": "Close message",
        "Zamknij menu": "Close menu",
        "Zamknij panel": "Close panel",
        "Zamknij pełny ekran": "Exit full screen",
        "Zamknij podgląd": "Close preview",
        "Zamknij projekt i otwórz ponownie folder właściwy dla wybranego programu. Jeśli pojawi się pytanie, zatwierdź zaufanie do projektu i serwera „edito”, a następnie ponów test odczytu.": "Close the project and reopen the folder for the selected program. If prompted, confirm trust in the project and the “edito” server, then retry the read test.",
        "Zamknij wybór plików": "Close file picker",
        "Zaokrąglenie rogów": "Corner radius",
        "Zapamiętaj logowanie": "Remember login",
        "Zapamiętane automatyczne logowanie dla tego urządzenia zostanie odwołane.": "Remembered automatic login for this device will be revoked.",
        "Zapamiętane urządzenia": "Remembered devices",
        "Zapis do:": "Save to:",
        "Zapis obejmuje filtry, sortowanie i kolumny.": "Saved view includes filters, sorting, and columns.",
        "Zapisane": "Saved",
        "Zapisane filtry": "Saved filters",
        "Zapisano pozycję widgetu %0.": "Widget position %0 saved.",
        "Zapisywanie obrazów zakończone.": "Image saving complete.",
        "Zapisywanie obrazów...": "Saving images...",
        "Zapisywanie obrazu...": "Saving image...",
        "Zapisz": "Save",
        "Zapisz aranżację": "Save arrangement",
        "Zapisz do katalogu": "Save to folder",
        "Zapisz i wróć": "Save and back",
        "Zapisz i zamknij": "Save and close",
        "Zapisz jako nowe pliki": "Save as new files",
        "Zapisz jako nowy": "Save as new",
        "Zapisz kolejność": "Save order",
        "Zapisz konfigurację w prywatnym folderze.": "Save configuration in private folder.",
        "Zapisz nazwę": "Save name",
        "Zapisz nowe hasło": "Save new password",
        "Zapisz ustawienia": "Save settings",
        "Zapisz użytkownika": "Save user",
        "Zapisz widget": "Save widget",
        "Zaplanowane": "Scheduled",
        "Zapytanie do modułu dynamicznego nie zwróciło żadnych rekordów.": "Dynamic module query returned no records.",
        "Zarządzaj aktywnymi sesjami i zaufanymi urządzeniami przypisanymi do Twojego konta.": "Manage active sessions and trusted devices linked to your account.",
        "Zarządzaj aplikacjami, które generują kody logowania do konta.": "Manage apps that generate login codes for your account.",
        "Zasady haseł": "Password policies",
        "Zastępstwo": "Substitution",
        "Zastosuj": "Apply",
        "Zastosuj modyfikacje": "Apply changes",
        "Zatrzymaj": "Stop",
        "Zatrzymaj odpowiedź": "Stop response",
        "Zatwierdź plan": "Approve plan",
        "Zaufane adresy IP": "Trusted IP addresses",
        "Zawieszeni 30 dni+": "Suspended 30+ days",
        "Zaznacz": "Select",
        "Zaznacz co najmniej jeden plik.": "Select at least one file.",
        "Zaznacz obraz": "Select image",
        "Zaznacz obrazy, które chcesz zapisać w katalogu.": "Select images to save to folder.",
        "Zaznacz pliki w bibliotece, aby pojawiły się tutaj.": "Select files in library to show them here.",
        "Zaznacz wiersz": "Select row",
        "Zaznacz wszystkie komórki": "Select all cells",
        "Zaznacz wszystkie wiersze": "Select all rows",
        "Zaznacz wszystko": "Select all",
        "Zaznaczenie jest zachowane przy zmianie folderu.": "Selection is retained when changing folders.",
        "Zaznaczenie zawiera plik w formacie niedozwolonym w tym polu.": "Selection contains a file in a format not allowed in this field.",
        "Zaznaczone zadania będą mogły korzystać z tego modelu.": "Selected tasks will be able to use this model.",
        "zaznaczono %0": "%0 selected",
        "Zbiera metryki środowiska uruchomieniowego .NET.": "Collects .NET runtime metrics.",
        "Zbieranie i przechowywanie logów": "Log collection and storage",
        "Zdarzenie": "Event",
        "Zdjęcie użytkownika": "User photo",
        "Zeskanuj kod QR": "Scan QR code",
        "Zeskanuj w aplikacji": "Scan in app",
        "Zespół": "Team",
        "Zespół w nowoczesnym biurze, naturalne światło": "Team in a modern office, natural light",
        "Zespół: %0": "Team: %0",
        "Zestaw został zaktualizowany.": "Set has been updated.",
        "Zestaw został zapisany.": "Set has been saved.",
        "Zewnętrzny MCP": "External MCP",
        "Zezwól - jawnie przyznane": "Allow - explicitly granted",
        "Zgodny z API OpenAI": "OpenAI API compatible",
        "zmian w planie": "plan changes",
        "Zmiana": "Change",
        "Zmiana filtrów": "Change filters",
        "Zmiana hasła": "Password change",
        "Zmiana jednego wymiaru zachowuje proporcje obrazu.": "Changing one dimension preserves image proportions.",
        "Zmiana optymalizacji wymiarów": "Change dimension optimization",
        "Zmiana pozycji znaku wodnego": "Change watermark position",
        "Zmiana proporcji kadrowania": "Change crop aspect ratio",
        "Zmiana rozmiaru kadru": "Change crop size",
        "Zmiana rozmiaru obrazu": "Image resizing",
        "Zmiana skali": "Change scale",
        "Zmiana trybu kadrowania": "Change crop mode",
        "Zmiana ustawień może doprowadzić do utraty dostępu do panelu!\n\nCzy na pewno chcesz zapisać zmiany?": "Changing settings may result in losing access to the panel!\n\nAre you sure you want to save changes?",
        "Zmiana wymiarów obrazu": "Change image dimensions",
        "Zmiana znaku wodnego": "Change watermark",
        "Zmiany niewykonane": "Changes not applied",
        "Zmiany pól": "Field changes",
        "Zmiany pominięte": "Changes skipped",
        "Zmiany ustawień monitoringu wymagają restartu aplikacji.": "Monitoring settings changes require application restart.",
        "Zmiany w planie": "Plan changes",
        "Zmiany zostały zapisane.": "Changes have been saved.",
        "Zmień": "Change",
        "Zmień filtry lub rozszerz zakres wyszukiwania.": "Change filters or expand search scope.",
        "Zmień hasło": "Change password",
        "Zmień hasło używane do logowania do konta.": "Change the password you use to log in to your account.",
        "Zmień kolejność elementów": "Reorder items",
        "Zmień kolejność wierszy": "Reorder rows",
        "Zmień komórki pierwszego wiersza lub kolumny na nagłówki TH.": "Change cells in first row or column to TH headers.",
        "Zmień lub skróć wpisaną frazę.": "Change or shorten the entered phrase.",
        "Zmień motyw: %0": "Change theme: %0",
        "Zmień nazwę": "Rename",
        "Zmień nazwę katalogu": "Rename directory",
        "Zmień nazwę pliku": "Rename file",
        "Zmień nazwę rozmowy": "Rename conversation",
        "Zmień nazwę urządzenia": "Rename device",
        "Zmień obraz": "Change image",
        "Zmień rozmiar": "Resize",
        "Zmień rozmiar okna": "Resize window",
        "Zmień ścieżkę zapisu": "Change save path",
        "Zmień szerokość okna": "Change window width",
        "Zmień szukaną nazwę uprawnienia lub modułu.": "Change searched privilege or module name.",
        "Zmień treść wiadomości...": "Change message text...",
        "Zmień wysokość okna": "Change window height",
        "Zmień wyszukiwanie lub wybrany stan.": "Change search or selected state.",
        "Zmienić wspólny zestaw dla innych użytkowników?": "Change shared set for other users?",
        "zmienione": "changed",
        "Zmienione": "Changed",
        "Zmieniono": "Changed",
        "Zmniejsz": "Decrease",
        "Zmniejsz duże obrazy do WWW": "Resize large images for the web",
        "Zmniejsz wcięcie": "Decrease indent",
        "Zmniejsza odstępy w komórkach, żeby tabela była gęstsza i zajmowała mniej miejsca.": "Reduces spacing in cells so the table is denser and takes up less space.",
        "zmodyfikował": "modified",
        "Zmodyfikował": "Modified",
        "Zmodyfikowano": "Modified",
        "zmodyfikowany": "modified",
        "Zmodyfikuj obraz": "Edit image",
        "Znaczniki": "Tags",
        "Znajdź i zamień": "Find and replace",
        "Znajdź ostatnio zmienione treści i krótko je podsumuj.": "Find recently changed content and briefly summarize it.",
        "Znajdź w treści": "Find in content",
        "Znajdź w treści…": "Find in content…",
        "Znak specjalny": "Special character",
        "Znak wodny": "Watermark",
        "Znaki": "Characters",
        "Znaki specjalne": "Special characters",
        "znaków": "characters",
        "Zobacz sesję użytkownika": "View user session",
        "Zobacz szczegóły sesji użytkownika": "View user session details",
        "Zobacz szczegóły zdarzenia": "View event details",
        "Zobacz wszystkie": "View all",
        "Zobacz wszystkie zmiany": "View all changes",
        "Zobacz wszystko": "View everything",
        "Żółty": "Yellow",
        "Został przywrócony oryginalny harmonogram": "Original schedule has been restored",
        "Zrestartuj aplikację": "Restart application",
        "Źródła logów": "Log sources",
        "Źródła uprawnień": "Privilege sources",
        "Źródło": "Source",
        "Źródło materiału": "Material source",
        "Źródło wariantu": "Variant source",
        "Zweryfikuj konfigurację integracji GA dla wybranej witryny i spróbuj odświeżyć dashboard.": "Verify GA integration configuration for selected site and try refreshing dashboard.",
        "Zwiększ": "Increase",
        "Zwiększ wcięcie": "Increase indent",
        "Zwiń": "Collapse",
        "Zwiń {name}": "Collapse {name}",
        "Zwiń menu": "Collapse menu",
        "Zwiń sekcję": "Collapse section",
        "Zwrócony": "Returned"
    }
};
